/**
  ---DO NOT EDIT THIS FILE DIRECTLY---
  This CSS file was concatenated from files listed in the css/ folder as part of a build process
  This is to allow for js import with @import links which will not be followed
**/

/* src/primitives/button/css/definition/content/button.css */
@layer button.definition.content.button {
  :host {
    -webkit-user-select: none;
    user-select: none;
    font-size: 1rem;
  }
  *,
  :after,
  :before {
    box-sizing: border-box;
    user-select: none;
    -webkit-user-select: none;
    -webkit-touch-callout: none;
  }
  .button {
    cursor: pointer;
    display: inline-block;
    min-height: 1em;
    border: var(--button-border);
    margin: 0em var(--button-horizontal-margin) var(--button-vertical-margin) 0em;
    vertical-align: var(--button-vertical-align);
    background: var(--button-background);
    color: var(--button-text-color);
    font-family: var(--button-font-family);
    padding: var(--button-padding);
    text-transform: var(--button-text-transform);
    text-shadow: var(--button-text-shadow);
    font-weight: var(--button-font-weight);
    line-height: var(--button-line-height);
    font-style: normal;
    text-align: var(--button-text-align);
    text-decoration: none;
    border-radius: var(--button-border-radius);
    box-shadow: var(--button-box-shadow);
    -webkit-user-select: none;
    user-select: none;
    transition: var(--button-transition);
    will-change: var(--button-will-change);
    -webkit-tap-highlight-color: var(--button-tap-color);
    outline: var(--button-border);
    width: var(--button-width);
  }
}

/* src/primitives/button/css/definition/content/icon.css */
@layer button.definition.content.icon {
  .button ui-icon,
  :slotted(ui-icon) {
    vertical-align: top;
    opacity: var(--button-icon-opacity);
  }
  :is(.button ui-icon, :slotted(ui-icon)):only-child {
    margin: 0rem;
  }
}

/* src/primitives/button/css/definition/content/label.css */
@layer button.definition.content.label;

/* src/primitives/button/css/definition/content/image.css */
@layer button.definition.content.image {
  .button ::slotted(img),
  .button ::slotted(ui-image) {
    display: inline-block;
    max-height: 1.5em;
    border-radius: 4px;
    vertical-align: top;
    margin: -0.25em 0.5rem -0.25em -0.25em;
  }
}

/* src/primitives/button/css/definition/content/badge.css */
@layer button.definition.content.badge {
  .button .badge,
  ::slotted(.badge) {
    margin: var(--button-badge-margin);
    --label-background: var(--black-10);
    --label-color: var(--button-text-color);
    --label-outline-text-color: var(--button-text-color);
    --label-outline: var(--solid-black-border);
  }
  .badge {
    outline: var(--border);
    padding: var(--button-vertical-padding) var(--padding-s);
    border-radius: var(--left-attached-border-radius);
    line-height: 1;
    outline-offset: -1px;
    text-align: center;
    display: inline-block;
    margin-right: -5px;
  }
  .badge + .button {
    border-radius: var(--right-attached-border-radius);
  }
}

/* src/primitives/button/css/definition/content/conditional.css */
@layer button.definition.content.conditional {
  .buttons ::slotted(.conditional) {
    position: relative;
    -webkit-user-select: auto;
    user-select: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    text-align: center;
    align-self: center;
    padding: var(--button-conditional-padding);
    color: var(--button-conditional-text-color);
    font-style: var(--button-conditional-text-style);
    font-weight: var(--button-conditional-text-weight);
    border-radius: var(--circular-radius);
    background-color: var(--button-conditional-background-color);
    text-shadow: var(--button-conditional-text-shadow);
    margin-left: var(--button-conditional-horizontal-offset);
    margin-right: var(--button-conditional-horizontal-offset);
    box-shadow: var(--button-conditional-box-shadow);
  }
}

/* src/primitives/button/css/definition/plural/buttons.css */
@layer button.definition.plural {
  .buttons {
    display: inline-flex;
    flex-wrap: nowrap;
    flex-direction: row;
    vertical-align: baseline;
    border-radius: var(--button-border-radius);
    margin: var(--button-vertical-margin) var(--button-horizontal-margin) 0em 0em;
  }
  .buttons:not(.basic):not(.inverted) {
    box-shadow: var(--button-group-box-shadow);
  }
  .buttons ::slotted(ui-button) {
    --button-border-radius: 0;
    --button-horizontal-margin: 0;
    margin: 0;
  }
  .buttons ::slotted(ui-button:is(:first-child)) {
    --button-border-radius: var(--button-group-button-border-radius) 0 0 var(--button-group-button-border-radius);
  }
  .buttons ::slotted(ui-button:is(:last-child)) {
    --button-border-radius: 0 var(--button-group-button-border-radius) var(--button-group-button-border-radius) 0;
  }
  .buttons ::slotted(ui-button:is(:only-child)) {
    --button-border-radius: var(--button-group-button-border-radius);
  }
}

/* src/primitives/button/css/definition/states/hover.css */
@layer button.definition.states.hover {
  @media (pointer: fine) {
    .button.hover,
    .button:hover {
      background-color: var(--button-hover-background-color);
      background-image: var(--button-hover-background-image);
      box-shadow: var(--button-hover-box-shadow);
      color: var(--button-hover-color);
    }
    :is(.button.hover, .button:hover) .icon {
      opacity: var(--button-hover-icon-opacity);
    }
  }
}

/* src/primitives/button/css/definition/states/focus.css */
@layer button.definition.states.focus {
  .button.focus,
  .button:focus-visible {
    position: relative;
    z-index: 2;
    background-color: var(--button-focus-background-color);
    background-image: var(--button-focus-background-image);
    color: var(--button-focus-color);
    box-shadow: var(--button-focus-box-shadow);
    box-shadow: var(--button-focus-box-shadow), var(--focused-ring-shadow) !important;
  }
  :is(.button.focus, .button:focus-visible) .icon {
    opacity: var(--button-focus-icon-opacity);
  }
}

/* src/primitives/button/css/definition/states/pressed.css */
@layer button.definition.states.pressed {
  @media (pointer: fine) {
    .button:active,
    .button.pressed {
      background-color: var(--button-pressed-background-color);
      background-image: var(--button-pressed-background-image);
      color: var(--button-pressed-color);
      box-shadow: var(--button-pressed-box-shadow);
    }
    .button.active:active,
    .button.active.pressed {
      background-color: var(--button-pressed-background-color);
      background-image: var(--button-pressed-background-image);
      color: var(--button-pressed-color);
      box-shadow: var(--button-pressed-box-shadow);
    }
  }
  .button.pressed {
    background-color: var(--button-pressed-background-color);
    background-image: var(--button-pressed-background-image);
    color: var(--button-pressed-color);
    box-shadow: var(--button-pressed-box-shadow);
  }
  .button.active.pressed {
    background-color: var(--button-pressed-background-color);
    background-image: var(--button-pressed-background-image);
    color: var(--button-pressed-color);
    box-shadow: var(--button-pressed-box-shadow);
  }
}

/* src/primitives/button/css/definition/states/active.css */
@layer button.definition.states.active {
  .button.active {
    background-color: var(--button-active-background-color);
    background-image: var(--button-active-background-image);
    box-shadow: var(--button-active-box-shadow);
    color: var(--button-active-color);
  }
  .button.active:hover {
    background-color: var(--button-active-hover-background-color);
    background-image: var(--button-active-hover-background-image);
    color: var(--button-active-hover-color);
    box-shadow: var(--button-active-hover-box-shadow);
  }
  .button.active:active {
    background-color: var(--button-active-down-background-color);
    background-image: var(--button-active-down-background-image);
    color: var(--button-active-down-color);
    box-shadow: var(--button-active-down-box-shadow);
  }
}

/* src/primitives/button/css/definition/states/disabled.css */
@layer button.definition.states.disabled {
  .button.disabled {
    pointer-events: none;
    cursor: var(--button-disabled-cursor);
    opacity: var(--button-disabled-opacity) !important;
    color: var(--button-disabled-color);
    box-shadow: var(--button-disabled-box-shadow) !important;
  }
  .button.disabled:hover {
    pointer-events: none;
    cursor: var(--button-disabled-cursor);
    opacity: var(--button-disabled-opacity) !important;
    color: var(--button-disabled-color);
    box-shadow: var(--button-disabled-box-shadow) !important;
  }
  .button.disabled.active {
    pointer-events: none;
    cursor: var(--button-disabled-cursor);
    opacity: var(--button-disabled-opacity) !important;
    color: var(--button-disabled-color);
    box-shadow: var(--button-disabled-box-shadow) !important;
  }
  .button.disabled.standard {
    background-color: var(--button-disabled-background-color) !important;
    background-image: var(--button-disabled-background-image) !important;
  }
  .button.clickable-disabled {
    pointer-events: auto !important;
    cursor: var(--button-clickable-disabled-cursor) !important;
  }
  .button.clickable-disabled:active {
    box-shadow: var(--button-pressed-box-shadow) !important;
  }
  ui-button[disabled] {
    cursor: var(--button-disabled-cursor);
    pointer-events: none !important;
  }
  ui-button[clickable-disabled] {
    pointer-events: auto !important;
    cursor: var(--button-clickable-disabled-cursor) !important;
  }
}

/* src/primitives/button/css/definition/states/loading.css */
@layer button.definition.states.loading {
  .button.loading:not(.icon) {
    position: relative;
    cursor: default;
    text-shadow: none !important;
    color: transparent !important;
    opacity: var(--button-loading-opacity);
    pointer-events: auto;
    transition: var(--button-loading-transition);
  }
  .button.loading:not(.icon)::before {
    position: absolute;
    content: "";
    top: 50%;
    left: 50%;
    margin: var(--loader-margin);
    width: var(--loader-size);
    height: var(--loader-size);
    border-radius: var(--circular-radius);
    border: var(--loader-line-width) solid var(--loader-fill-color);
  }
  .button.loading:not(.icon)::after {
    position: absolute;
    content: "";
    top: 50%;
    left: 50%;
    margin: var(--loader-margin);
    width: var(--loader-size);
    height: var(--loader-size);
    animation: button-spin var(--loader-speed) linear;
    animation-iteration-count: infinite;
    border-radius: var(--circular-radius);
    border-color: var(--loader-line-color) transparent transparent;
    border-style: solid;
    border-width: var(--loader-line-width);
    box-shadow: 0px 0px 0px 1px transparent;
  }
  .button.loading.icon .icon {
    position: relative;
    color: transparent !important;
  }
  .button.loading.icon .icon:before {
    position: absolute;
    content: "";
    top: 50%;
    left: 50%;
    margin: var(--loader-margin);
    width: var(--loader-size);
    height: var(--loader-size);
    border-radius: var(--circular-radius);
    border: var(--loader-line-width) solid var(--loader-fill-color);
  }
  .button.loading.icon .icon:after {
    position: absolute;
    content: "";
    top: 50%;
    left: 50%;
    margin: var(--loader-margin);
    width: var(--loader-size);
    height: var(--loader-size);
    animation: button-spin var(--loader-speed) linear;
    animation-iteration-count: infinite;
    border-radius: var(--circular-radius);
    border-color: var(--loader-line-color) transparent transparent;
    border-style: solid;
    border-width: var(--loader-line-width);
    box-shadow: 0px 0px 0px 1px transparent;
  }
  .button.loading.inverted:before {
    border-color: var(--inverted-loader-fill-color);
  }
  .button.loading.inverted:after {
    border-top-color: var(--inverted-loader-line-color);
  }
  .button.loading.inverted .icon:before {
    border-color: var(--inverted-loader-fill-color);
  }
  .button.loading.inverted .icon:after {
    border-top-color: var(--inverted-loader-line-color);
  }
  @keyframes button-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}

/* src/primitives/button/css/definition/types/link.css */
@layer button.definition.types.link {
  .link.button {
    background: none;
    box-shadow: none;
    padding: var(--button-link-padding);
    text-decoration: var(--button-link-text-decoration);
    color: var(--button-link-text-color);
    text-shadow: none;
    --button-hover-box-shadow: none;
    --button-pressed-box-shadow: none;
    --button-colored-box-shadow: none;
    --button-primary-box-shadow: none;
    --button-secondary-box-shadow: none;
    --button-colored-background-image: none;
    --button-primary-background-image: none;
    --button-secondary-background-image: none;
  }
  .link.button.hover,
  .link.button:hover {
    background: none;
    color: var(--button-link-text-color-hover);
    text-decoration: var(--button-link-text-decoration-hover);
  }
  .link.button.pressed,
  .link.button:active,
  .link.button.active {
    background: none;
    color: var(--button-link-text-color-hover);
  }
  .link.buttons ::slotted(ui-button) {
    --button-background: none;
    --button-box-shadow: none;
    --button-padding: var(--button-link-padding);
    --button-text-decoration: var(--button-link-text-decoration);
    --button-text-color: var(--button-link-text-color);
    --button-text-shadow: none;
    --button-hover-background: none;
    --button-hover-background-image: none;
    --button-hover-box-shadow: none;
    --button-pressed-background: none;
    --button-pressed-background-image: none;
    --button-pressed-box-shadow: none;
    --button-active-background: none;
    --button-colored-background-image: none;
    --button-colored-box-shadow: none;
    --button-primary-background-image: none;
    --button-primary-box-shadow: none;
    --button-secondary-background-image: none;
    --button-secondary-box-shadow: none;
  }
}

/* src/primitives/button/css/definition/types/styled.css */
@layer button.definition.types.styled {
  .styled.button {
    background: var(--button-styled-background);
    color: var(--button-styled-color);
    box-shadow: var(--button-styled-box-shadow);
    text-shadow: var(--button-styled-text-shadow);
  }
  .styled.button.hover,
  .styled.button:hover {
    background-color: var(--button-styled-hover-background);
    color: var(--button-styled-hover-color);
  }
  .styled.button.pressed,
  .styled.button:active {
    background-color: var(--button-styled-pressed-background);
    color: var(--button-styled-pressed-color);
  }
  .styled.button .active {
    background-color: var(--button-styled-active-background);
    color: var(--button-styled-active-color);
  }
  .styled.buttons:not(.separate) ::slotted(ui-button) {
    --button-box-shadow: none;
    --button-hover-box-shadow: none;
    --button-pressed-box-shadow: none;
  }
  .styled.buttons ::slotted(ui-button) {
    --button-background: var(--button-styled-background);
    --button-text-shadow: var(--button-styled-text-shadow);
    --button-text-color: var(--button-styled-color);
    --button-hover-background-color: var(--button-styled-hover-background);
    --button-hover-color: var(--button-styled-hover-color);
    --button-pressed-background-color: var(--button-styled-pressed-background);
    --button-pressed-color: var(--button-styled-pressed-color);
    --button-background-image: none;
    --button-colored-background-image: none;
    --button-primary-background-image: none;
    --button-secondary-background-image: none;
  }
  .subtle.buttons:not(.separate) {
    box-shadow: var(--button-box-shadow);
  }
  .flat.button,
  .flat.buttons ::slotted(ui-button) {
    --button-group-box-shadow: var(--button-box-shadow);
    --button-box-shadow: none;
    --button-hover-box-shadow: none;
    --button-pressed-box-shadow: none;
    --button-colored-box-shadow: none;
    --button-primary-box-shadow: none;
    --button-secondary-box-shadow: none;
  }
  .flat.buttons,
  .flat.button {
    box-shadow: none;
  }
  .outline.button,
  .outline.buttons ::slotted(ui-button) {
    --button-background: none;
    --button-hover-background-image: none;
    --button-pressed-background-image: none;
    --button-colored-background-image: none;
    --button-primary-background-image: none;
    --button-secondary-background-image: none;
    --button-hover-box-shadow: none;
    --button-pressed-box-shadow: none;
    --button-colored-box-shadow: none;
    --button-primary-box-shadow: none;
    --button-secondary-box-shadow: none;
  }
  .outline.button {
    background: none;
    box-shadow: none;
    outline: var(--button-outline-border-width) solid var(--button-outline-border-color);
    outline-offset: var(--button-outline-border-offset);
  }
  .outline.buttons {
    background: none;
    box-shadow: none;
    border: var(--border);
  }
  .ghost.button {
    box-shadow: none;
  }
  .ghost.button:not(:is(:hover, .hover, :active, .pressed, .active)) {
    background: none;
  }
  .ghost.buttons ::slotted(ui-button) {
    --button-box-shadow: none;
    --button-background: none;
    --button-text-color: var(--text-color);
    --button-background-hover: var(--button-styled-background-hover);
    --button-hover-color: var(--button-styled-color);
    --button-background-pressed: var(--button-styled-background-pressed);
    --button-background-pressed-color: var(--button-styled-background-pressed-color);
    --button-background-active: var(--button-styled-background-active);
    --button-background-active-color: var(--button-styled-background-active-color);
    --button-background: none;
    --button-hover-background-image: none;
    --button-pressed-background-image: none;
    --button-colored-background-image: none;
    --button-primary-background-image: none;
    --button-secondary-background-image: none;
    --button-hover-box-shadow: none;
    --button-pressed-box-shadow: none;
    --button-colored-box-shadow: none;
    --button-primary-box-shadow: none;
    --button-secondary-box-shadow: none;
  }
}

/* src/primitives/button/css/definition/types/animated.css */
@layer button.definition.types.animated {
  .button.animated {
    position: relative;
    overflow: hidden;
    padding-right: 0em !important;
    vertical-align: var(--button-animated-vertical-align);
    z-index: var(--button-animated-z-index);
  }
  .button.animated > .content {
    display: inline-block;
    box-sizing: border-box;
    will-change: transform, opacity;
  }
  .button.animated > .visible.content {
    position: relative;
    margin-right: var(--button-horizontal-padding);
  }
  .button.animated > .hidden.content {
    position: absolute;
    width: 100%;
  }
  .button.animated.animated > .visible.content,
  .button.animated > .hidden.content {
    transition: right var(--button-animation-duration) var(--button-animation-easing) 0s;
  }
  .button.animated > .visible.content {
    left: auto;
    right: 0%;
  }
  .button.animated > .hidden.content {
    top: 50%;
    left: auto;
    right: -100%;
    margin-top: calc(var(--button-line-height) / 2 * -1);
  }
  :is(.button.animated:focus, .button.animated:hover) > .visible.content {
    left: auto;
    right: 200%;
  }
  :is(.button.animated:focus, .button.animated:hover) > .hidden.content {
    left: auto;
    right: 0%;
  }
  .button.animated.vertical > .visible.content,
  .button.animated.vertical > .hidden.content {
    transition: top var(--button-animation-duration) var(--button-animation-easing), transform var(--button-animation-duration) var(--button-animation-easing);
  }
  .button.animated.vertical > .visible.content {
    transform: translateY(0%);
    right: auto;
  }
  .button.animated.vertical > .hidden.content {
    top: -50%;
    left: 0%;
  }
  :is(.button.animated.vertical:focus, .button.animated.vertical:hover) > .visible.content {
    transform: translateY(200%);
    right: auto;
  }
  :is(.button.animated.vertical:focus, .button.animated.vertical:hover) > .hidden.content {
    top: 50%;
  }
  .button.animated.fade > .visible.content,
  .button.animated.fade > .hidden.content {
    transition: opacity var(--button-animation-duration) var(--button-animation-easing), transform var(--button-animation-duration) var(--button-animation-easing);
  }
  .button.animated.fade > .visible.content {
    left: auto;
    right: auto;
    opacity: 1;
    transform: scale(1);
  }
  .button.animated.fade > .hidden.content {
    opacity: 0;
    left: 0%;
    right: auto;
    transform: scale(var(--button-fade-scale-high));
  }
  :is(.button.animated.fade:focus, .button.animated.fade:hover) > .visible.content {
    left: auto;
    right: auto;
    opacity: 0;
    transform: scale(var(--button-fade-scale-low));
  }
  :is(.button.animated.fade:focus, .button.animated.fade:hover) > .hidden.content {
    left: 0%;
    right: auto;
    opacity: 1;
    transform: scale(1);
  }
}

/* src/primitives/button/css/definition/types/emphasis.css */
@layer button.definition.types.emphasis {
  .primary.buttons .button,
  .primary.button {
    background-color: var(--button-primary-color);
    color: var(--button-primary-text-color);
    text-shadow: var(--button-primary-text-shadow);
    background-image: var(--button-primary-background-image);
    --button-link-text-color: var(--button-primary-color);
    --button-link-text-color-hover: var(--button-primary-color-hover);
    --button-styled-background: var(--primary-background-color);
    --button-styled-text-color: var(--primary-text-color);
    --button-styled-background-hover: var(--primary-5);
    --button-styled-background-pressed: var(--primary-10);
    --button-styled-text-color-hover: var(--primary-text-color-hover);
    --button-styled-text-color-pressed: var(--primary-text-color-pressed);
    --button-styled-text-color-active: var(--primary-text-color-pressed);
  }
  :is(.primary.buttons .button, .primary.button):hover {
    background-color: var(--button-primary-color-hover);
    color: var(--button-primary-text-color);
    text-shadow: var(--button-primary-text-shadow);
    box-shadow: var(--button-hover-box-shadow);
  }
  :is(.primary.buttons .button, .primary.button):focus {
    background-color: var(--button-primary-color-focus);
    color: var(--button-primary-text-color);
    text-shadow: var(--button-primary-text-shadow);
    box-shadow: var(--button-focus-box-shadow);
  }
  :is(.primary.buttons .button, .primary.button).pressed,
  :is(.primary.buttons .button, .primary.button):active {
    background-color: var(--button-primary-color-down);
    color: var(--button-primary-text-color);
    text-shadow: var(--button-primary-text-shadow);
    box-shadow: var(--button-pressed-box-shadow);
  }
  :is(.primary.buttons .button, .primary.button).active {
    background-color: var(--button-primary-color-active);
    color: var(--button-primary-text-color);
    text-shadow: var(--button-primary-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
  :is(.primary.buttons .button, .primary.button).active:active {
    background-color: var(--button-primary-color-active);
    color: var(--button-primary-text-color);
    text-shadow: var(--button-primary-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
  .primary.button {
    box-shadow: var(--button-primary-box-shadow);
  }
  .primary.button .active.button:active {
    background-color: var(--button-primary-color-active);
    color: var(--button-primary-text-color);
    text-shadow: var(--button-primary-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
  .secondary.buttons .button,
  .secondary.button {
    background-color: var(--button-secondary-color);
    color: var(--button-secondary-text-color);
    text-shadow: var(--button-secondary-text-shadow);
    background-image: var(--button-colored-background-image);
    --button-link-text-color: var(--button-secondary-color);
    --button-link-text-color-hover: var(--button-secondary-color-hover);
    --button-styled-background: var(--secondary-background-color);
    --button-styled-text-color: var(--secondary-text-color);
    --button-styled-background-hover: var(--secondary-5);
    --button-styled-background-pressed: var(--secondary-10);
    --button-styled-text-color-hover: var(--secondary-text-color-hover);
    --button-styled-text-color-pressed: var(--secondary-text-color-pressed);
    --button-styled-text-color-active: var(--secondary-text-color-pressed);
  }
  :is(.secondary.buttons .button, .secondary.button):hover {
    background-color: var(--button-secondary-color-hover);
    color: var(--button-secondary-text-color);
    text-shadow: var(--button-secondary-text-shadow);
    box-shadow: var(--button-hover-box-shadow);
  }
  :is(.secondary.buttons .button, .secondary.button):focus {
    background-color: var(--button-secondary-color-focus);
    color: var(--button-secondary-text-color);
    text-shadow: var(--button-secondary-text-shadow);
    box-shadow: var(--button-focus-box-shadow);
  }
  :is(.secondary.buttons .button, .secondary.button).pressed,
  :is(.secondary.buttons .button, .secondary.button):active {
    background-color: var(--button-secondary-color-down);
    color: var(--button-secondary-text-color);
    text-shadow: var(--button-secondary-text-shadow);
    box-shadow: var(--button-pressed-box-shadow);
  }
  :is(.secondary.buttons .button, .secondary.button).active {
    background-color: var(--button-secondary-color-active);
    color: var(--button-secondary-text-color);
    text-shadow: var(--button-secondary-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
  :is(.secondary.buttons .button, .secondary.button).active:active {
    background-color: var(--button-secondary-color-active);
    color: var(--button-secondary-text-color);
    text-shadow: var(--button-secondary-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
  .secondary.button {
    box-shadow: var(--button-colored-box-shadow);
  }
  .secondary.button .active.button:active {
    background-color: var(--button-secondary-color-active);
    color: var(--button-secondary-text-color);
    text-shadow: var(--button-secondary-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
}

/* src/primitives/button/css/definition/types/icon.css */
@layer button.definition.types.icon {
  .icon-only.buttons .button,
  .icon-only.button {
    padding: var(--button-vertical-padding);
  }
  :is(.icon-only.buttons .button, .icon-only.button) > ui-icon {
    opacity: 1;
    margin: 0em;
    vertical-align: top;
  }
  .icon-after.buttons .button > ui-icon,
  .icon-after.button > ui-icon {
    margin-right: 0rem;
    margin-left: var(--icon-distance-from-text);
  }
}

/* src/primitives/button/css/definition/types/labeled.css */
@layer button.definition.types.labeled {
  .labeled.button:not(.icon) {
    display: inline-flex;
    flex-direction: row;
    background: none !important;
    padding: 0px !important;
    border: none !important;
    box-shadow: none !important;
  }
  .labeled.button:not(.icon) > .button {
    margin: 0px;
  }
  .labeled.button:not(.icon) > .label {
    display: flex;
    align-items: var(--labeled-label-align);
    margin: 0px 0px 0px var(--labeled-label-border-offset) !important;
    padding: var(--labeled-label-padding);
    font-size: var(--labeled-label-font-size);
    border-color: var(--labeled-label-border-color);
  }
  .labeled.button:not(.icon) > .tag.label::before {
    width: var(--labeled-tag-label-size);
    height: var(--labeled-tag-label-size);
  }
  .labeled.button:not(.icon):not([class*="left labeled"]) > .button {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }
  .labeled.button:not(.icon):not([class*="left labeled"]) > .label {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }
  [class*="left labeled"].button > .button {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }
  [class*="left labeled"].button > .label {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }
}

/* src/primitives/button/css/definition/types/labeled-icon.css */
@layer button.definition.types.labeled-icon {
  .labeled.icon.buttons .button,
  .labeled.icon.button {
    position: relative;
    padding-left: var(--labeled-icon-padding) !important;
    padding-right: var(--horizontal-padding) !important;
  }
  :is(.labeled.icon.buttons .button, .labeled.icon.button) > .icon {
    position: absolute;
    height: 100%;
    line-height: 1;
    border-radius: 0px;
    border-top-left-radius: inherit;
    border-bottom-left-radius: inherit;
    text-align: center;
    margin: var(--labeled-icon-margin);
    width: var(--labeled-icon-width);
    background-color: var(--labeled-icon-background-color);
    color: var(--labeled-icon-color);
    box-shadow: var(--labeled-icon-left-shadow);
    top: 0em;
    left: 0em;
  }
  :is(.labeled.icon.buttons .button, .labeled.icon.button) > .icon::before,
  :is(.labeled.icon.buttons .button, .labeled.icon.button) > .icon::after {
    display: block;
    position: absolute;
    width: 100%;
    top: 50%;
    text-align: center;
    transform: translateY(-50%);
  }
  :is(.labeled.icon.buttons .button, .labeled.icon.button) > .icon.loading {
    animation: none;
  }
  :is(.labeled.icon.buttons .button, .labeled.icon.button) > .icon.loading::before {
    animation: labeled-button-icon-loading var(--loading-icon-duration) linear infinite;
  }
  [class*="right labeled"].icon.button {
    padding-right: var(--labeled-icon-padding) !important;
    padding-left: var(--horizontal-padding) !important;
  }
  [class*="right labeled"].icon.button > .icon {
    left: auto;
    right: 0em;
    border-radius: 0px;
    border-top-right-radius: inherit;
    border-bottom-right-radius: inherit;
    box-shadow: var(--labeled-icon-right-shadow);
  }
  @keyframes labeled-button-icon-loading {
    from {
      transform: translateY(-50%) rotate(0deg);
    }
    to {
      transform: translateY(-50%) rotate(360deg);
    }
  }
  .labeled.icon.buttons .button > .icon {
    border-radius: 0em;
  }
  .labeled.icon.buttons .button:first-child > .icon {
    border-top-left-radius: var(--border-radius);
    border-bottom-left-radius: var(--border-radius);
  }
  .labeled.icon.buttons .button:last-child > .icon {
    border-top-right-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
  }
  .vertical.labeled.icon.buttons .button:first-child > .icon {
    border-radius: 0em;
    border-top-left-radius: var(--border-radius);
  }
  .vertical.labeled.icon.buttons .button:last-child > .icon {
    border-radius: 0em;
    border-bottom-left-radius: var(--border-radius);
  }
  .fluid[class*="left labeled"].icon.button,
  .fluid[class*="right labeled"].icon.button {
    padding-left: var(--horizontal-padding) !important;
    padding-right: var(--horizontal-padding) !important;
  }
}

/* src/primitives/button/css/definition/types/transparent.css */
@layer button.definition.types.transparent {
  .transparent.button {
    background-image: var(--button-transparent-background-image);
    background-color: var(--button-transparent-background-color);
    color: var(--button-transparent-text-color);
    box-shadow: var(--button-transparent-box-shadow) !important;
  }
  .transparent.button:hover {
    background-image: var(--button-transparent-hover-background-image);
    background-color: var(--button-transparent-hover-background-color);
    color: var(--button-transparent-hover-text-color);
    box-shadow: var(--button-transparent-hover-box-shadow) !important;
  }
  .transparent.button:active {
    background-image: var(--button-transparent-pressed-background-image);
    background-color: var(--button-transparent-pressed-background-color);
    color: var(--button-transparent-pressed-text-color);
    box-shadow: var(--button-transparent-pressed-box-shadow) !important;
  }
  .transparent.button.active {
    background-image: var(--button-transparent-active-background-image);
    background-color: var(--button-transparent-active-background-color);
    color: var(--button-transparent-active-text-color) !important;
    box-shadow: var(--button-transparent-active-box-shadow) !important;
  }
}

/* src/primitives/button/css/definition/types/toggle.css */
@layer button.definition.types.toggle {
  .toggle.buttons .active.button,
  .buttons .button.toggle.active,
  .button.toggle.active {
    background-color: var(--button-toggle-active-background) !important;
    color: var(--button-toggle-active-color) !important;
    text-shadow: var(--button-toggle-active-text-shadow);
  }
  :is(.toggle.buttons .active.button, .buttons .button.toggle.active, .button.toggle.active):hover {
    background-color: var(--button-toggle-active-hover-background) !important;
    color: var(--button-toggle-active-hover-color) !important;
  }
}

/* src/primitives/button/css/definition/variations/attached.css */
@layer button.definition.variations.attached {
  .attached.button {
    position: relative;
    display: block;
    margin-left: var(--button-attached-offset);
    margin-right: var(--button-attached-offset);
    border-radius: 0em;
  }
  .top-attached.button {
    border-radius: var(--button-attached-top);
  }
  .bottom-attached.button {
    border-radius: var(--button-attached-bottom);
  }
  .left-attached.button {
    display: inline-block;
    border-left: none;
    text-align: right;
    border-radius: var(--button-attached-left);
  }
  .right-attached.button {
    display: inline-block;
    text-align: left;
    border-radius: var(--button-attached-right);
  }
  .attached.buttons {
    position: relative;
    display: flex;
    width: auto;
    z-index: var(--button-attached-z-index);
    margin-left: var(--button-attached-offset);
    margin-right: var(--button-attached-offset);
  }
  .attached.buttons ::slotted(ui-button) {
    --button-border-radius: var(--button-group-attached-none);
    margin: 0;
  }
  .top-attached.buttons {
    margin-bottom: var(--button-attached-offset);
    border-radius: var(--button-group-attached-top);
  }
  .top-attached.buttons ::slotted(ui-button:first-child) {
    --button-border-radius: var(--button-group-attached-top-left);
  }
  .top-attached.buttons ::slotted(ui-button:last-child) {
    --button-border-radius: var(--button-group-attached-top-right);
  }
  .top-attached.buttons ::slotted(ui-button:only-child) {
    --button-border-radius: var(--button-group-attached-top);
  }
  .bottom-attached.buttons {
    margin-top: var(--button-attached-offset);
    border-radius: var(--button-group-attached-bottom);
  }
  .bottom-attached.buttons ::slotted(ui-button:first-child) {
    --button-border-radius: var(--button-group-attached-bottom-left);
  }
  .bottom-attached.buttons ::slotted(ui-button:last-child) {
    --button-border-radius: var(--button-group-attached-bottom-right);
  }
  .bottom-attached.buttons ::slotted(ui-button:only-child) {
    --button-border-radius: var(--button-group-attached-bottom);
  }
  .left-attached.buttons {
    margin-right: 0em;
    margin-left: var(--button-attached-offset);
  }
  .left-attached.buttons ::slotted(ui-button:first-child) {
    --button-border-radius: var(--button-group-attached-left);
  }
  .left-attached.buttons ::slotted(ui-button:not(:first-child)) {
    --button-border-radius: var(--button-group-attached-none);
  }
  .left-attached.buttons ::slotted(ui-button:only-child) {
    --button-border-radius: var(--button-group-attached-left);
  }
  .right-attached.buttons {
    margin-left: 0em;
    margin-right: var(--button-attached-offset);
  }
  .right-attached.buttons ::slotted(ui-button:not(:last-child)) {
    --button-border-radius: var(--button-group-attached-none);
  }
  .right-attached.buttons ::slotted(ui-button:last-child) {
    --button-border-radius: var(--button-group-attached-right);
  }
  .right-attached.buttons ::slotted(ui-button:only-child) {
    --button-border-radius: var(--button-group-attached-right);
  }
  .vertical.attached.buttons {
    flex-direction: column;
  }
  .vertical.attached.buttons ::slotted(ui-button) {
    --button-border-radius: var(--button-group-attached-none);
    width: 100%;
  }
  .vertical.attached.buttons ::slotted(ui-button:first-child) {
    --button-border-radius: var(--button-group-attached-top);
  }
  .vertical.attached.buttons ::slotted(ui-button:last-child) {
    --button-border-radius: var(--button-group-attached-bottom);
  }
  .vertical.attached.buttons ::slotted(ui-button:only-child) {
    --button-border-radius: var(--button-group-attached-all);
  }
}

/* src/primitives/button/css/definition/variations/circular.css */
@layer button.definition.variations.circular {
  .circular.button {
    border-radius: var(--circular-radius);
  }
  .circular.button > .icon {
    width: 1em;
    vertical-align: baseline;
  }
}

/* src/primitives/button/css/definition/variations/colored.css */
@layer button.definition.variations.colored {
  .color.buttons,
  .color.button {
    --button-background-image: var(--button-colored-background-image);
  }
  .red.buttons ::slotted(ui-button),
  .red.button {
    --button-background-color: var(--button-red);
    --button-background: var(--button-background-color) var(--button-colored-background-image);
    --button-text-color: var(--button-red-text-color);
    --button-text-shadow: var(--button-red-text-shadow);
    --button-box-shadow: var(--button-colored-box-shadow);
    --button-hover-color: var(--button-red-text-color);
    --button-hover-text-shadow: var(--button-red-text-shadow);
    --button-hover-background-color: var(--button-red-hover);
    --button-hover-box-shadow: var(--button-colored-box-shadow);
    --button-focus-background-color: var(--button-red-focus);
    --button-focus-color: var(--button-red-text-color);
    --button-focus-text-shadow: var(--button-red-text-shadow);
    --button-pressed-background-color: var(--button-red-pressed);
    --button-pressed-color: var(--button-red-text-color);
    --button-pressed-text-shadow: var(--button-red-text-shadow);
    --button-active-background-color: var(--button-red-pressed);
    --button-active-color: var(--button-red-text-color);
    --button-active-text-shadow: var(--button-red-text-shadow);
    --button-link-text-color: var(--button-red);
    --button-link-text-color-hover: var(--button-red-hover);
    --button-styled-background: var(--red-background-color);
    --button-styled-color: var(--red-text-color);
    --button-styled-hover-background: var(--red-5);
    --button-styled-hover-color: var(--red-text-color-hover);
    --button-styled-pressed-background: var(--red-10);
    --button-styled-pressed-color: var(--red-text-color-pressed);
    --button-styled-active-background: var(--red-10);
    --button-styled-active-color: var(--red-text-color-pressed);
    --button-outline-border-color: var(--red-border-color);
  }
  .orange.buttons ::slotted(ui-button),
  .orange.button {
    --button-background-color: var(--button-orange);
    --button-background: var(--button-background-color) var(--button-colored-background-image);
    --button-text-color: var(--button-orange-text-color);
    --button-text-shadow: var(--button-orange-text-shadow);
    --button-box-shadow: var(--button-colored-box-shadow);
    --button-hover-color: var(--button-orange-text-color);
    --button-hover-text-shadow: var(--button-orange-text-shadow);
    --button-hover-background-color: var(--button-orange-hover);
    --button-hover-box-shadow: var(--button-colored-box-shadow);
    --button-focus-background-color: var(--button-orange-focus);
    --button-focus-color: var(--button-orange-text-color);
    --button-focus-text-shadow: var(--button-orange-text-shadow);
    --button-pressed-background-color: var(--button-orange-pressed);
    --button-pressed-color: var(--button-orange-text-color);
    --button-pressed-text-shadow: var(--button-orange-text-shadow);
    --button-active-background-color: var(--button-orange-pressed);
    --button-active-color: var(--button-orange-text-color);
    --button-active-text-shadow: var(--button-orange-text-shadow);
    --button-link-text-color: var(--button-orange);
    --button-link-text-color-hover: var(--button-orange-hover);
    --button-styled-background: var(--orange-background-color);
    --button-styled-color: var(--orange-text-color);
    --button-styled-hover-background: var(--orange-5);
    --button-styled-hover-color: var(--orange-text-color-hover);
    --button-styled-pressed-background: var(--orange-10);
    --button-styled-pressed-color: var(--orange-text-color-pressed);
    --button-styled-active-background: var(--orange-10);
    --button-styled-active-color: var(--orange-text-color-pressed);
    --button-outline-border-color: var(--orange-border-color);
  }
  .yellow.buttons ::slotted(ui-button),
  .yellow.button {
    --button-background-color: var(--button-yellow);
    --button-background: var(--button-background-color) var(--button-colored-background-image);
    --button-text-color: var(--button-yellow-text-color);
    --button-text-shadow: var(--button-yellow-text-shadow);
    --button-box-shadow: var(--button-colored-box-shadow);
    --button-hover-color: var(--button-yellow-text-color);
    --button-hover-text-shadow: var(--button-yellow-text-shadow);
    --button-hover-background-color: var(--button-yellow-hover);
    --button-hover-box-shadow: var(--button-colored-box-shadow);
    --button-focus-background-color: var(--button-yellow-focus);
    --button-focus-color: var(--button-yellow-text-color);
    --button-focus-text-shadow: var(--button-yellow-text-shadow);
    --button-pressed-background-color: var(--button-yellow-pressed);
    --button-pressed-color: var(--button-yellow-text-color);
    --button-pressed-text-shadow: var(--button-yellow-text-shadow);
    --button-active-background-color: var(--button-yellow-pressed);
    --button-active-color: var(--button-yellow-text-color);
    --button-active-text-shadow: var(--button-yellow-text-shadow);
    --button-link-text-color: var(--button-yellow);
    --button-link-text-color-hover: var(--button-yellow-hover);
    --button-styled-background: var(--yellow-background-color);
    --button-styled-color: var(--yellow-text-color);
    --button-styled-hover-background: var(--yellow-5);
    --button-styled-hover-color: var(--yellow-text-color-hover);
    --button-styled-pressed-background: var(--yellow-10);
    --button-styled-pressed-color: var(--yellow-text-color-pressed);
    --button-styled-active-background: var(--yellow-10);
    --button-styled-active-color: var(--yellow-text-color-pressed);
    --button-outline-border-color: var(--yellow-border-color);
  }
  .olive.buttons ::slotted(ui-button),
  .olive.button {
    --button-background-color: var(--button-olive);
    --button-background: var(--button-background-color) var(--button-colored-background-image);
    --button-text-color: var(--button-olive-text-color);
    --button-text-shadow: var(--button-olive-text-shadow);
    --button-box-shadow: var(--button-colored-box-shadow);
    --button-hover-color: var(--button-olive-text-color);
    --button-hover-text-shadow: var(--button-olive-text-shadow);
    --button-hover-background-color: var(--button-olive-hover);
    --button-hover-box-shadow: var(--button-colored-box-shadow);
    --button-focus-background-color: var(--button-olive-focus);
    --button-focus-color: var(--button-olive-text-color);
    --button-focus-text-shadow: var(--button-olive-text-shadow);
    --button-pressed-background-color: var(--button-olive-pressed);
    --button-pressed-color: var(--button-olive-text-color);
    --button-pressed-text-shadow: var(--button-olive-text-shadow);
    --button-active-background-color: var(--button-olive-pressed);
    --button-active-color: var(--button-olive-text-color);
    --button-active-text-shadow: var(--button-olive-text-shadow);
    --button-link-text-color: var(--button-olive);
    --button-link-text-color-hover: var(--button-olive-hover);
    --button-styled-background: var(--olive-background-color);
    --button-styled-color: var(--olive-text-color);
    --button-styled-hover-background: var(--olive-5);
    --button-styled-hover-color: var(--olive-text-color-hover);
    --button-styled-pressed-background: var(--olive-10);
    --button-styled-pressed-color: var(--olive-text-color-pressed);
    --button-styled-active-background: var(--olive-10);
    --button-styled-active-color: var(--olive-text-color-pressed);
    --button-outline-border-color: var(--olive-border-color);
  }
  .green.buttons ::slotted(ui-button),
  .green.button {
    --button-background-color: var(--button-green);
    --button-background: var(--button-background-color) var(--button-colored-background-image);
    --button-text-color: var(--button-green-text-color);
    --button-text-shadow: var(--button-green-text-shadow);
    --button-box-shadow: var(--button-colored-box-shadow);
    --button-hover-color: var(--button-green-text-color);
    --button-hover-text-shadow: var(--button-green-text-shadow);
    --button-hover-background-color: var(--button-green-hover);
    --button-hover-box-shadow: var(--button-colored-box-shadow);
    --button-focus-background-color: var(--button-green-focus);
    --button-focus-color: var(--button-green-text-color);
    --button-focus-text-shadow: var(--button-green-text-shadow);
    --button-pressed-background-color: var(--button-green-pressed);
    --button-pressed-color: var(--button-green-text-color);
    --button-pressed-text-shadow: var(--button-green-text-shadow);
    --button-active-background-color: var(--button-green-pressed);
    --button-active-color: var(--button-green-text-color);
    --button-active-text-shadow: var(--button-green-text-shadow);
    --button-link-text-color: var(--button-green);
    --button-link-text-color-hover: var(--button-green-hover);
    --button-styled-background: var(--green-background-color);
    --button-styled-color: var(--green-text-color);
    --button-styled-hover-background: var(--green-5);
    --button-styled-hover-color: var(--green-text-color-hover);
    --button-styled-pressed-background: var(--green-10);
    --button-styled-pressed-color: var(--green-text-color-pressed);
    --button-styled-active-background: var(--green-10);
    --button-styled-active-color: var(--green-text-color-pressed);
    --button-outline-border-color: var(--green-border-color);
  }
  .teal.buttons ::slotted(ui-button),
  .teal.button {
    --button-background-color: var(--button-teal);
    --button-background: var(--button-background-color) var(--button-colored-background-image);
    --button-text-color: var(--button-teal-text-color);
    --button-text-shadow: var(--button-teal-text-shadow);
    --button-box-shadow: var(--button-colored-box-shadow);
    --button-hover-color: var(--button-teal-text-color);
    --button-hover-text-shadow: var(--button-teal-text-shadow);
    --button-hover-background-color: var(--button-teal-hover);
    --button-hover-box-shadow: var(--button-colored-box-shadow);
    --button-focus-background-color: var(--button-teal-focus);
    --button-focus-color: var(--button-teal-text-color);
    --button-focus-text-shadow: var(--button-teal-text-shadow);
    --button-pressed-background-color: var(--button-teal-pressed);
    --button-pressed-color: var(--button-teal-text-color);
    --button-pressed-text-shadow: var(--button-teal-text-shadow);
    --button-active-background-color: var(--button-teal-pressed);
    --button-active-color: var(--button-teal-text-color);
    --button-active-text-shadow: var(--button-teal-text-shadow);
    --button-link-text-color: var(--button-teal);
    --button-link-text-color-hover: var(--button-teal-hover);
    --button-styled-background: var(--teal-background-color);
    --button-styled-color: var(--teal-text-color);
    --button-styled-hover-background: var(--teal-5);
    --button-styled-hover-color: var(--teal-text-color-hover);
    --button-styled-pressed-background: var(--teal-10);
    --button-styled-pressed-color: var(--teal-text-color-pressed);
    --button-styled-active-background: var(--teal-10);
    --button-styled-active-color: var(--teal-text-color-pressed);
    --button-outline-border-color: var(--teal-border-color);
  }
  .blue.buttons ::slotted(ui-button),
  .blue.button {
    --button-background-color: var(--button-blue);
    --button-background: var(--button-background-color) var(--button-colored-background-image);
    --button-text-color: var(--button-blue-text-color);
    --button-text-shadow: var(--button-blue-text-shadow);
    --button-box-shadow: var(--button-colored-box-shadow);
    --button-hover-color: var(--button-blue-text-color);
    --button-hover-text-shadow: var(--button-blue-text-shadow);
    --button-hover-background-color: var(--button-blue-hover);
    --button-hover-box-shadow: var(--button-colored-box-shadow);
    --button-focus-background-color: var(--button-blue-focus);
    --button-focus-color: var(--button-blue-text-color);
    --button-focus-text-shadow: var(--button-blue-text-shadow);
    --button-pressed-background-color: var(--button-blue-pressed);
    --button-pressed-color: var(--button-blue-text-color);
    --button-pressed-text-shadow: var(--button-blue-text-shadow);
    --button-active-background-color: var(--button-blue-pressed);
    --button-active-color: var(--button-blue-text-color);
    --button-active-text-shadow: var(--button-blue-text-shadow);
    --button-link-text-color: var(--button-blue);
    --button-link-text-color-hover: var(--button-blue-hover);
    --button-styled-background: var(--blue-background-color);
    --button-styled-color: var(--blue-text-color);
    --button-styled-hover-background: var(--blue-5);
    --button-styled-hover-color: var(--blue-text-color-hover);
    --button-styled-pressed-background: var(--blue-10);
    --button-styled-pressed-color: var(--blue-text-color-pressed);
    --button-styled-active-background: var(--blue-10);
    --button-styled-active-color: var(--blue-text-color-pressed);
    --button-outline-border-color: var(--blue-border-color);
  }
  .violet.buttons ::slotted(ui-button),
  .violet.button {
    --button-background-color: var(--button-violet);
    --button-background: var(--button-background-color) var(--button-colored-background-image);
    --button-text-color: var(--button-violet-text-color);
    --button-text-shadow: var(--button-violet-text-shadow);
    --button-box-shadow: var(--button-colored-box-shadow);
    --button-hover-color: var(--button-violet-text-color);
    --button-hover-text-shadow: var(--button-violet-text-shadow);
    --button-hover-background-color: var(--button-violet-hover);
    --button-hover-box-shadow: var(--button-colored-box-shadow);
    --button-focus-background-color: var(--button-violet-focus);
    --button-focus-color: var(--button-violet-text-color);
    --button-focus-text-shadow: var(--button-violet-text-shadow);
    --button-pressed-background-color: var(--button-violet-pressed);
    --button-pressed-color: var(--button-violet-text-color);
    --button-pressed-text-shadow: var(--button-violet-text-shadow);
    --button-active-background-color: var(--button-violet-pressed);
    --button-active-color: var(--button-violet-text-color);
    --button-active-text-shadow: var(--button-violet-text-shadow);
    --button-link-text-color: var(--button-violet);
    --button-link-text-color-hover: var(--button-violet-hover);
    --button-styled-background: var(--violet-background-color);
    --button-styled-color: var(--violet-text-color);
    --button-styled-hover-background: var(--violet-5);
    --button-styled-hover-color: var(--violet-text-color-hover);
    --button-styled-pressed-background: var(--violet-10);
    --button-styled-pressed-color: var(--violet-text-color-pressed);
    --button-styled-active-background: var(--violet-10);
    --button-styled-active-color: var(--violet-text-color-pressed);
    --button-outline-border-color: var(--violet-border-color);
  }
  .purple.buttons ::slotted(ui-button),
  .purple.button {
    --button-background-color: var(--button-purple);
    --button-background: var(--button-background-color) var(--button-colored-background-image);
    --button-text-color: var(--button-purple-text-color);
    --button-text-shadow: var(--button-purple-text-shadow);
    --button-box-shadow: var(--button-colored-box-shadow);
    --button-hover-color: var(--button-purple-text-color);
    --button-hover-text-shadow: var(--button-purple-text-shadow);
    --button-hover-background-color: var(--button-purple-hover);
    --button-hover-box-shadow: var(--button-colored-box-shadow);
    --button-focus-background-color: var(--button-purple-focus);
    --button-focus-color: var(--button-purple-text-color);
    --button-focus-text-shadow: var(--button-purple-text-shadow);
    --button-pressed-background-color: var(--button-purple-pressed);
    --button-pressed-color: var(--button-purple-text-color);
    --button-pressed-text-shadow: var(--button-purple-text-shadow);
    --button-active-background-color: var(--button-purple-pressed);
    --button-active-color: var(--button-purple-text-color);
    --button-active-text-shadow: var(--button-purple-text-shadow);
    --button-link-text-color: var(--button-purple);
    --button-link-text-color-hover: var(--button-purple-hover);
    --button-styled-background: var(--purple-background-color);
    --button-styled-color: var(--purple-text-color);
    --button-styled-hover-background: var(--purple-5);
    --button-styled-hover-color: var(--purple-text-color-hover);
    --button-styled-pressed-background: var(--purple-10);
    --button-styled-pressed-color: var(--purple-text-color-pressed);
    --button-styled-active-background: var(--purple-10);
    --button-styled-active-color: var(--purple-text-color-pressed);
    --button-outline-border-color: var(--purple-border-color);
  }
  .pink.buttons ::slotted(ui-button),
  .pink.button {
    --button-background-color: var(--button-pink);
    --button-background: var(--button-background-color) var(--button-colored-background-image);
    --button-text-color: var(--button-pink-text-color);
    --button-text-shadow: var(--button-pink-text-shadow);
    --button-box-shadow: var(--button-colored-box-shadow);
    --button-hover-color: var(--button-pink-text-color);
    --button-hover-text-shadow: var(--button-pink-text-shadow);
    --button-hover-background-color: var(--button-pink-hover);
    --button-hover-box-shadow: var(--button-colored-box-shadow);
    --button-focus-background-color: var(--button-pink-focus);
    --button-focus-color: var(--button-pink-text-color);
    --button-focus-text-shadow: var(--button-pink-text-shadow);
    --button-pressed-background-color: var(--button-pink-pressed);
    --button-pressed-color: var(--button-pink-text-color);
    --button-pressed-text-shadow: var(--button-pink-text-shadow);
    --button-active-background-color: var(--button-pink-pressed);
    --button-active-color: var(--button-pink-text-color);
    --button-active-text-shadow: var(--button-pink-text-shadow);
    --button-link-text-color: var(--button-pink);
    --button-link-text-color-hover: var(--button-pink-hover);
    --button-styled-background: var(--pink-background-color);
    --button-styled-color: var(--pink-text-color);
    --button-styled-hover-background: var(--pink-5);
    --button-styled-hover-color: var(--pink-text-color-hover);
    --button-styled-pressed-background: var(--pink-10);
    --button-styled-pressed-color: var(--pink-text-color-pressed);
    --button-styled-active-background: var(--pink-10);
    --button-styled-active-color: var(--pink-text-color-pressed);
    --button-outline-border-color: var(--pink-border-color);
  }
  .brown.buttons ::slotted(ui-button),
  .brown.button {
    --button-background-color: var(--button-brown);
    --button-background: var(--button-background-color) var(--button-colored-background-image);
    --button-text-color: var(--button-brown-text-color);
    --button-text-shadow: var(--button-brown-text-shadow);
    --button-box-shadow: var(--button-colored-box-shadow);
    --button-hover-color: var(--button-brown-text-color);
    --button-hover-text-shadow: var(--button-brown-text-shadow);
    --button-hover-background-color: var(--button-brown-hover);
    --button-hover-box-shadow: var(--button-colored-box-shadow);
    --button-focus-background-color: var(--button-brown-focus);
    --button-focus-color: var(--button-brown-text-color);
    --button-focus-text-shadow: var(--button-brown-text-shadow);
    --button-pressed-background-color: var(--button-brown-pressed);
    --button-pressed-color: var(--button-brown-text-color);
    --button-pressed-text-shadow: var(--button-brown-text-shadow);
    --button-active-background-color: var(--button-brown-pressed);
    --button-active-color: var(--button-brown-text-color);
    --button-active-text-shadow: var(--button-brown-text-shadow);
    --button-link-text-color: var(--button-brown);
    --button-link-text-color-hover: var(--button-brown-hover);
    --button-styled-background: var(--brown-background-color);
    --button-styled-color: var(--brown-text-color);
    --button-styled-hover-background: var(--brown-5);
    --button-styled-hover-color: var(--brown-text-color-hover);
    --button-styled-pressed-background: var(--brown-10);
    --button-styled-pressed-color: var(--brown-text-color-pressed);
    --button-styled-active-background: var(--brown-10);
    --button-styled-active-color: var(--brown-text-color-pressed);
    --button-outline-border-color: var(--brown-border-color);
  }
  .grey.buttons ::slotted(ui-button),
  .grey.button {
    --button-background-color: var(--button-grey);
    --button-background: var(--button-background-color) var(--button-colored-background-image);
    --button-text-color: var(--button-grey-text-color);
    --button-text-shadow: var(--button-grey-text-shadow);
    --button-box-shadow: var(--button-colored-box-shadow);
    --button-hover-color: var(--button-grey-text-color);
    --button-hover-text-shadow: var(--button-grey-text-shadow);
    --button-hover-background-color: var(--button-grey-hover);
    --button-hover-box-shadow: var(--button-colored-box-shadow);
    --button-focus-background-color: var(--button-grey-focus);
    --button-focus-color: var(--button-grey-text-color);
    --button-focus-text-shadow: var(--button-grey-text-shadow);
    --button-pressed-background-color: var(--button-grey-pressed);
    --button-pressed-color: var(--button-grey-text-color);
    --button-pressed-text-shadow: var(--button-grey-text-shadow);
    --button-active-background-color: var(--button-grey-pressed);
    --button-active-color: var(--button-grey-text-color);
    --button-active-text-shadow: var(--button-grey-text-shadow);
    --button-link-text-color: var(--button-grey);
    --button-link-text-color-hover: var(--button-grey-hover);
    --button-styled-background: var(--grey-background-color);
    --button-styled-color: var(--grey-text-color);
    --button-styled-hover-background: var(--grey-5);
    --button-styled-hover-color: var(--grey-text-color-hover);
    --button-styled-pressed-background: var(--grey-10);
    --button-styled-pressed-color: var(--grey-text-color-pressed);
    --button-styled-active-background: var(--grey-10);
    --button-styled-active-color: var(--grey-text-color-pressed);
    --button-outline-border-color: var(--grey-border-color);
  }
  .slate.buttons ::slotted(ui-button),
  .slate.button {
    --button-background-color: var(--button-slate);
    --button-background: var(--button-background-color) var(--button-colored-background-image);
    --button-text-color: var(--button-slate-text-color);
    --button-text-shadow: var(--button-slate-text-shadow);
    --button-box-shadow: var(--button-colored-box-shadow);
    --button-hover-color: var(--button-slate-text-color);
    --button-hover-text-shadow: var(--button-slate-text-shadow);
    --button-hover-background-color: var(--button-slate-hover);
    --button-hover-box-shadow: var(--button-colored-box-shadow);
    --button-focus-background-color: var(--button-slate-focus);
    --button-focus-color: var(--button-slate-text-color);
    --button-focus-text-shadow: var(--button-slate-text-shadow);
    --button-pressed-background-color: var(--button-slate-pressed);
    --button-pressed-color: var(--button-slate-text-color);
    --button-pressed-text-shadow: var(--button-slate-text-shadow);
    --button-active-background-color: var(--button-slate-pressed);
    --button-active-color: var(--button-slate-text-color);
    --button-active-text-shadow: var(--button-slate-text-shadow);
    --button-link-text-color: var(--button-slate);
    --button-link-text-color-hover: var(--button-slate-hover);
    --button-styled-background: var(--slate-background-color);
    --button-styled-color: var(--slate-text-color);
    --button-styled-hover-background: var(--slate-5);
    --button-styled-hover-color: var(--slate-text-color-hover);
    --button-styled-pressed-background: var(--slate-10);
    --button-styled-pressed-color: var(--slate-text-color-pressed);
    --button-styled-active-background: var(--slate-10);
    --button-styled-active-color: var(--slate-text-color-pressed);
    --button-outline-border-color: var(--slate-border-color);
  }
}

/* src/primitives/button/css/definition/variations/compact.css */
@layer button.definition.variations.compact {
  .compact.button {
    padding: var(--button-compact-padding);
  }
  .compact.button.icon {
    padding: var(--button-compact-icon-padding);
  }
  .compact.buttons ::slotted(ui-button) {
    --button-padding: var(--button-compact-padding);
  }
  .compact.buttons.icon ::slotted(ui-button) {
    --button-padding: var(--button-compact-icon-padding);
  }
  .very-compact.button {
    padding: var(--button-very-compact-padding);
  }
  .very-compact.button.icon {
    padding: var(--button-very-compact-icon-padding);
  }
  .very-compact.buttons ::slotted(ui-button) {
    --button-padding: var(--button-very-compact-padding);
  }
  .very-compact.buttons.icon ::slotted(ui-button) {
    --button-padding: var(--button-very-compact-icon-padding);
  }
}

/* src/primitives/button/css/definition/variations/equal-width.css */
@layer button.definition.variations.equal-width {
  .equal-width.buttons {
    display: grid;
    width: 100%;
  }
  .equal-width.buttons ::slotted(ui-button) {
    width: 100%;
    --button-width: 100%;
    --button-horizontal-margin: 0;
    margin: 0;
  }
  .equal-width.buttons.two {
    grid-template-columns: repeat(2, 1fr);
  }
  .equal-width.buttons.three {
    grid-template-columns: repeat(3, 1fr);
  }
  .equal-width.buttons.four {
    grid-template-columns: repeat(4, 1fr);
  }
  .equal-width.buttons.five {
    grid-template-columns: repeat(5, 1fr);
  }
  .equal-width.buttons.six {
    grid-template-columns: repeat(6, 1fr);
  }
  .equal-width.buttons.vertical {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
  .equal-width.buttons.vertical ::slotted(ui-button) {
    --button-vertical-margin: 0;
  }
}

/* src/primitives/button/css/definition/variations/floated.css */
@layer button.definition.variations.floated {
  .left-floated.buttons,
  .left-floated.button {
    float: left;
    margin-left: 0em;
    margin-right: var(--button-floated-margin);
  }
  .right-floated.buttons,
  .right-floated.button {
    float: right;
    margin-right: 0em;
    margin-left: var(--button-floated-margin);
  }
}

/* src/primitives/button/css/definition/variations/fluid.css */
@layer button.definition.variations.fluid {
  .fluid.buttons,
  .fluid.button {
    width: 100%;
  }
  .fluid.buttons,
  .fluid.button {
    display: block;
  }
}

/* src/primitives/button/css/definition/variations/negative.css */
@layer button.definition.variations.negative {
  .negative.buttons .button,
  .negative.button {
    background-color: var(--button-negative-color);
    color: var(--button-negative-text-color);
    text-shadow: var(--button-negative-text-shadow);
    background-image: var(--button-colored-background-image);
  }
  :is(.negative.buttons .button, .negative.button):hover {
    background-color: var(--button-negative-color-hover);
    color: var(--button-negative-text-color);
    text-shadow: var(--button-negative-text-shadow);
    box-shadow: var(--button-hover-box-shadow);
  }
  :is(.negative.buttons .button, .negative.button):focus {
    background-color: var(--button-negative-color-focus);
    color: var(--button-negative-text-color);
    text-shadow: var(--button-negative-text-shadow);
    box-shadow: var(--button-focus-box-shadow);
  }
  :is(.negative.buttons .button, .negative.button).pressed,
  :is(.negative.buttons .button, .negative.button):active {
    background-color: var(--button-negative-color-down);
    color: var(--button-negative-text-color);
    text-shadow: var(--button-negative-text-shadow);
    box-shadow: var(--button-pressed-box-shadow);
  }
  :is(.negative.buttons .button, .negative.button).active {
    background-color: var(--button-negative-color-active);
    color: var(--button-negative-text-color);
    text-shadow: var(--button-negative-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
  :is(.negative.buttons .button, .negative.button).active:active {
    background-color: var(--button-negative-color-active);
    color: var(--button-negative-text-color);
    text-shadow: var(--button-negative-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
  .negative.button {
    box-shadow: var(--button-negative-box-shadow);
  }
  .negative.button .active.button:active {
    background-color: var(--button-negative-color-active);
    color: var(--button-negative-text-color);
    text-shadow: var(--button-negative-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
  .subtle-negative.buttons .button,
  .subtle-negative.button {
    background-color: var(--button-subtle-negative-color);
    color: var(--button-subtle-negative-text-color);
    text-shadow: var(--button-subtle-negative-text-shadow);
    background-image: var(--button-subtle-negative-background-image);
  }
  :is(.subtle-negative.buttons .button, .subtle-negative.button):hover {
    background-color: var(--button-subtle-negative-color-hover);
    color: var(--button-subtle-negative-text-color);
    text-shadow: var(--button-subtle-negative-text-shadow);
    box-shadow: var(--button-hover-box-shadow);
  }
  :is(.subtle-negative.buttons .button, .subtle-negative.button):focus {
    background-color: var(--button-subtle-negative-color-focus);
    color: var(--button-subtle-negative-text-color);
    text-shadow: var(--button-subtle-negative-text-shadow);
    box-shadow: var(--button-focus-box-shadow);
  }
  :is(.subtle-negative.buttons .button, .subtle-negative.button).pressed,
  :is(.subtle-negative.buttons .button, .subtle-negative.button):active {
    background-color: var(--button-subtle-negative-color-down);
    color: var(--button-subtle-negative-text-color);
    text-shadow: var(--button-subtle-negative-text-shadow);
    box-shadow: var(--button-pressed-box-shadow);
  }
  :is(.subtle-negative.buttons .button, .subtle-negative.button).active {
    background-color: var(--button-subtle-negative-color-active);
    background-image: var(--button-subtle-negative-background-image);
    color: var(--button-subtle-negative-text-color);
    text-shadow: var(--button-subtle-negative-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
  :is(.subtle-negative.buttons .button, .subtle-negative.button).active:active {
    background-color: var(--button-subtle-negative-color-active);
    background-image: var(--button-subtle-negative-background-image);
    color: var(--button-subtle-negative-text-color);
    text-shadow: var(--button-subtle-negative-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
  :is(.subtle-negative.buttons .button, .subtle-negative.button) > .icon {
    color: var(--button-subtle-negative-text-color);
  }
  .subtle-negative.button {
    box-shadow: var(--button-subtle-negative-box-shadow);
  }
  .subtle-negative.button .active.button:active {
    background-color: var(--button-subtle-negative-color-active);
    background-image: var(--button-subtle-negative-background-image);
    color: var(--button-subtle-negative-text-color);
    text-shadow: var(--button-subtle-negative-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
}

/* src/primitives/button/css/definition/variations/positive.css */
@layer button.definition.variations.positive {
  .positive.buttons .button,
  .positive.button {
    background-color: var(--button-positive-color);
    color: var(--button-positive-text-color);
    text-shadow: var(--button-positive-text-shadow);
    background-image: var(--button-positive-background-image);
  }
  :is(.positive.buttons .button, .positive.button):hover {
    background-color: var(--button-positive-color-hover);
    color: var(--button-positive-text-color);
    text-shadow: var(--button-positive-text-shadow);
    box-shadow: var(--button-hover-box-shadow);
  }
  :is(.positive.buttons .button, .positive.button):focus {
    background-color: var(--button-positive-color-focus);
    color: var(--button-positive-text-color);
    text-shadow: var(--button-positive-text-shadow);
    box-shadow: var(--button-focus-box-shadow);
  }
  :is(.positive.buttons .button, .positive.button).pressed,
  :is(.positive.buttons .button, .positive.button):active {
    background-color: var(--button-positive-color-down);
    color: var(--button-positive-text-color);
    text-shadow: var(--button-positive-text-shadow);
    box-shadow: var(--button-pressed-box-shadow);
  }
  :is(.positive.buttons .button, .positive.button).active {
    background-color: var(--button-positive-color-active);
    color: var(--button-positive-text-color);
    text-shadow: var(--button-positive-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
  :is(.positive.buttons .button, .positive.button).active:active {
    background-color: var(--button-positive-color-active);
    color: var(--button-positive-text-color);
    text-shadow: var(--button-positive-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
  .positive.button {
    box-shadow: var(--button-positive-box-shadow);
  }
  .positive.button .active.button:active {
    background-color: var(--button-positive-color-active);
    color: var(--button-positive-text-color);
    text-shadow: var(--button-positive-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
  .subtle-positive.buttons .button,
  .subtle-positive.button {
    background-color: var(--button-subtle-positive-color);
    color: var(--button-subtle-positive-text-color);
    text-shadow: var(--button-subtle-positive-text-shadow);
    background-image: var(--button-subtle-positive-background-image);
  }
  :is(.subtle-positive.buttons .button, .subtle-positive.button):hover {
    background-color: var(--button-subtle-positive-color-hover);
    color: var(--button-subtle-positive-text-color);
    text-shadow: var(--button-subtle-positive-text-shadow);
    box-shadow: var(--button-hover-box-shadow);
  }
  :is(.subtle-positive.buttons .button, .subtle-positive.button):focus {
    background-color: var(--button-subtle-positive-color-focus);
    color: var(--button-subtle-positive-text-color);
    text-shadow: var(--button-subtle-positive-text-shadow);
    box-shadow: var(--button-focus-box-shadow);
  }
  :is(.subtle-positive.buttons .button, .subtle-positive.button).pressed,
  :is(.subtle-positive.buttons .button, .subtle-positive.button):active {
    background-color: var(--button-subtle-positive-color-down);
    color: var(--button-subtle-positive-text-color);
    text-shadow: var(--button-subtle-positive-text-shadow);
    box-shadow: var(--button-pressed-box-shadow);
  }
  :is(.subtle-positive.buttons .button, .subtle-positive.button).active {
    background-color: var(--button-subtle-positive-color-active);
    background-image: var(--button-subtle-positive-background-image);
    color: var(--button-subtle-positive-text-color);
    text-shadow: var(--button-subtle-positive-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
  :is(.subtle-positive.buttons .button, .subtle-positive.button).active:active {
    background-color: var(--button-subtle-positive-color-active);
    background-image: var(--button-subtle-positive-background-image);
    color: var(--button-subtle-positive-text-color);
    text-shadow: var(--button-subtle-positive-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
  :is(.subtle-positive.buttons .button, .subtle-positive.button) > .icon {
    color: var(--button-subtle-positive-text-color);
  }
  .subtle-positive.button {
    box-shadow: var(--button-subtle-positive-box-shadow);
  }
  .subtle-positive.button .active.button:active {
    background-color: var(--button-subtle-positive-color-active);
    background-image: var(--button-subtle-positive-background-image);
    color: var(--button-subtle-positive-text-color);
    text-shadow: var(--button-subtle-positive-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
}

/* src/primitives/button/css/definition/variations/warning.css */
@layer button.definition.variations.warning {
  .warning.buttons .button,
  .warning.button {
    background-color: var(--button-warning-color);
    color: var(--button-warning-text-color);
    text-shadow: var(--button-warning-text-shadow);
    background-image: var(--button-colored-background-image);
  }
  :is(.warning.buttons .button, .warning.button):hover {
    background-color: var(--button-warning-color-hover);
    color: var(--button-warning-text-color);
    text-shadow: var(--button-warning-text-shadow);
    box-shadow: var(--button-hover-box-shadow);
  }
  :is(.warning.buttons .button, .warning.button):focus {
    background-color: var(--button-warning-color-focus);
    color: var(--button-warning-text-color);
    text-shadow: var(--button-warning-text-shadow);
    box-shadow: var(--button-focus-box-shadow);
  }
  :is(.warning.buttons .button, .warning.button):active {
    background-color: var(--button-warning-color-down);
    color: var(--button-warning-text-color);
    text-shadow: var(--button-warning-text-shadow);
  }
  :is(.warning.buttons .button, .warning.button).active {
    background-color: var(--button-warning-color-active);
    color: var(--button-warning-text-color);
    text-shadow: var(--button-warning-text-shadow);
  }
  :is(.warning.buttons .button, .warning.button).active:active {
    background-color: var(--button-warning-color-active);
    color: var(--button-warning-text-color);
    text-shadow: var(--button-warning-text-shadow);
  }
  .warning.button {
    box-shadow: var(--button-warning-box-shadow);
  }
  .warning.button .active.button:active {
    background-color: var(--button-warning-color-active);
    color: var(--button-warning-text-color);
    text-shadow: var(--button-warning-text-shadow);
  }
  .subtle-warning.buttons .button,
  .subtle-warning.button {
    background-color: var(--button-subtle-warning-color);
    color: var(--button-subtle-warning-text-color);
    text-shadow: var(--button-subtle-warning-text-shadow);
    background-image: var(--button-subtle-warning-background-image);
  }
  :is(.subtle-warning.buttons .button, .subtle-warning.button):hover {
    background-color: var(--button-subtle-warning-color-hover);
    color: var(--button-subtle-warning-text-color);
    text-shadow: var(--button-subtle-warning-text-shadow);
    box-shadow: var(--button-hover-box-shadow);
  }
  :is(.subtle-warning.buttons .button, .subtle-warning.button):focus {
    background-color: var(--button-subtle-warning-color-focus);
    color: var(--button-subtle-warning-text-color);
    text-shadow: var(--button-subtle-warning-text-shadow);
    box-shadow: var(--button-focus-box-shadow);
  }
  :is(.subtle-warning.buttons .button, .subtle-warning.button):active {
    background-color: var(--button-subtle-warning-color-down);
    color: var(--button-subtle-warning-text-color);
    text-shadow: var(--button-subtle-warning-text-shadow);
    box-shadow: var(--button-pressed-box-shadow);
  }
  :is(.subtle-warning.buttons .button, .subtle-warning.button).active {
    background-color: var(--button-subtle-warning-color-active);
    background-image: var(--button-subtle-warning-background-image);
    color: var(--button-subtle-warning-text-color);
    text-shadow: var(--button-subtle-warning-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
  :is(.subtle-warning.buttons .button, .subtle-warning.button).active:active {
    background-color: var(--button-subtle-warning-color-active);
    background-image: var(--button-subtle-warning-background-image);
    color: var(--button-subtle-warning-text-color);
    text-shadow: var(--button-subtle-warning-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
  :is(.subtle-warning.buttons .button, .subtle-warning.button) > .icon {
    color: var(--button-subtle-warning-text-color);
  }
  .subtle-warning.button {
    box-shadow: var(--button-subtle-warning-box-shadow);
  }
  .subtle-warning.button .active.button:active {
    background-color: var(--button-subtle-warning-color-active);
    background-image: var(--button-subtle-warning-background-image);
    color: var(--button-subtle-warning-text-color);
    text-shadow: var(--button-subtle-warning-text-shadow);
    box-shadow: var(--button-active-box-shadow);
  }
}

/* src/primitives/button/css/definition/variations/info.css */
@layer button.definition.variations.info {
  .info.buttons .button,
  .info.button {
    background-color: var(--button-info-color);
    color: var(--button-info-text-color);
    text-shadow: var(--button-info-text-shadow);
    background-image: var(--button-colored-background-image);
  }
  :is(.info.buttons .button, .info.button):hover {
    background-color: var(--button-info-color-hover);
    color: var(--button-info-text-color);
    text-shadow: var(--button-info-text-shadow);
  }
  :is(.info.buttons .button, .info.button):focus {
    background-color: var(--button-info-color-focus);
    color: var(--button-info-text-color);
    text-shadow: var(--button-info-text-shadow);
  }
  :is(.info.buttons .button, .info.button).pressed,
  :is(.info.buttons .button, .info.button):active {
    background-color: var(--button-info-color-down);
    color: var(--button-info-text-color);
    text-shadow: var(--button-info-text-shadow);
  }
  :is(.info.buttons .button, .info.button).active {
    background-color: var(--button-info-color-active);
    color: var(--button-info-text-color);
    text-shadow: var(--button-info-text-shadow);
  }
  :is(.info.buttons .button, .info.button).active:active {
    background-color: var(--button-info-color-active);
    color: var(--button-info-text-color);
    text-shadow: var(--button-info-text-shadow);
  }
  .info.button {
    box-shadow: var(--button-info-box-shadow);
  }
  .info.button .active.button:active {
    background-color: var(--button-info-color-active);
    color: var(--button-info-text-color);
    text-shadow: var(--button-info-text-shadow);
  }
  .subtle-info.buttons .button,
  .subtle-info.button {
    background-color: var(--button-subtle-info-color);
    color: var(--button-subtle-info-text-color);
    text-shadow: var(--button-subtle-info-text-shadow);
    background-image: var(--button-subtle-info-background-image);
  }
  :is(.subtle-info.buttons .button, .subtle-info.button):hover {
    background-color: var(--button-subtle-info-color-hover);
    color: var(--button-subtle-info-text-color);
    text-shadow: var(--button-subtle-info-text-shadow);
  }
  :is(.subtle-info.buttons .button, .subtle-info.button):focus {
    background-color: var(--button-subtle-info-color-focus);
    color: var(--button-subtle-info-text-color);
    text-shadow: var(--button-subtle-info-text-shadow);
  }
  :is(.subtle-info.buttons .button, .subtle-info.button).pressed,
  :is(.subtle-info.buttons .button, .subtle-info.button):active {
    background-color: var(--button-subtle-info-color-down);
    color: var(--button-subtle-info-text-color);
    text-shadow: var(--button-subtle-info-text-shadow);
  }
  :is(.subtle-info.buttons .button, .subtle-info.button).active {
    background-color: var(--button-subtle-info-color-active);
    background-image: var(--button-subtle-info-background-image);
    color: var(--button-subtle-info-text-color);
    text-shadow: var(--button-subtle-info-text-shadow);
  }
  :is(.subtle-info.buttons .button, .subtle-info.button).active:active {
    background-color: var(--button-subtle-info-color-active);
    background-image: var(--button-subtle-info-background-image);
    color: var(--button-subtle-info-text-color);
    text-shadow: var(--button-subtle-info-text-shadow);
  }
  :is(.subtle-info.buttons .button, .subtle-info.button) > .icon {
    color: var(--button-subtle-info-text-color);
  }
  .subtle-info.button {
    box-shadow: var(--button-subtle-info-box-shadow);
  }
  .subtle-info.button .active.button:active {
    background-color: var(--button-subtle-info-color-active);
    background-image: var(--button-subtle-info-background-image);
    color: var(--button-subtle-info-text-color);
    text-shadow: var(--button-subtle-info-text-shadow);
  }
}

/* src/primitives/button/css/definition/variations/separate.css */
@layer button.definition.variations.separate {
  .separate.buttons {
    box-shadow: none;
  }
  .separate.buttons ::slotted(ui-button) {
    --button-horizontal-margin: var(--button-separate-spacing);
    --button-border-radius: var(--border-radius);
  }
  .separate.buttons.vertical {
    --button-vertical-margin: var(--button-separate-spacing);
  }
}

/* src/primitives/button/css/definition/variations/sizing.css */
@layer button.definition.variations.sizing {
  .mini.button {
    font-size: var(--button-mini);
  }
  .tiny.button {
    font-size: var(--button-tiny);
  }
  .small.button {
    font-size: var(--button-small);
  }
  :host {
    font-size: var(--button-medium);
  }
  .large.button {
    font-size: var(--button-large);
  }
  .big.button {
    font-size: var(--button-big);
  }
  .huge.button {
    font-size: var(--button-huge);
  }
  .massive.button {
    font-size: var(--button-massive);
  }
  .mini.buttons {
    --button-medium: var(--button-mini);
  }
  .tiny.buttons {
    --button-medium: var(--button-tiny);
  }
  .small.buttons {
    --button-medium: var(--button-small);
  }
  .large.buttons {
    --button-medium: var(--button-large);
  }
  .big.buttons {
    --button-medium: var(--button-big);
  }
  .huge.buttons {
    --button-medium: var(--button-huge);
  }
  .massive.buttons {
    --button-medium: var(--button-massive);
  }
}

/* src/primitives/button/css/definition/variations/social.css */
@layer button.definition.variations.social {
  .social.button .icon {
    opacity: 1;
  }
  .facebook.button {
    background-color: var(--facebook-color);
    color: var(--button-inverted-text-color);
    text-shadow: var(--button-inverted-text-shadow);
    background-image: var(--button-colored-background-image);
    box-shadow: var(--button-colored-box-shadow);
  }
  .facebook.button:hover {
    background-color: var(--facebook-hover-color);
    color: var(--button-inverted-text-color);
    text-shadow: var(--button-inverted-text-shadow);
  }
  .facebook.button:active {
    background-color: var(--facebook-down-color);
    color: var(--button-inverted-text-color);
    text-shadow: var(--button-inverted-text-shadow);
  }
  .twitter.button {
    background-color: var(--twitter-color);
    color: var(--button-inverted-text-color);
    text-shadow: var(--button-inverted-text-shadow);
    background-image: var(--button-colored-background-image);
    box-shadow: var(--button-colored-box-shadow);
  }
  .twitter.button:hover {
    background-color: var(--twitter-hover-color);
    color: var(--button-inverted-text-color);
    text-shadow: var(--button-inverted-text-shadow);
  }
  .twitter.button:active {
    background-color: var(--twitter-down-color);
    color: var(--button-inverted-text-color);
    text-shadow: var(--button-inverted-text-shadow);
  }
  .linkedin.button {
    background-color: var(--linked-in-color);
    color: var(--button-inverted-text-color);
    text-shadow: var(--button-inverted-text-shadow);
  }
  .linkedin.button:hover {
    background-color: var(--linked-in-hover-color);
    color: var(--button-inverted-text-color);
    text-shadow: var(--button-inverted-text-shadow);
  }
  .linkedin.button:active {
    background-color: var(--linked-in-down-color);
    color: var(--button-inverted-text-color);
    text-shadow: var(--button-inverted-text-shadow);
  }
  .youtube.button {
    background-color: var(--youtube-color);
    color: var(--button-inverted-text-color);
    text-shadow: var(--button-inverted-text-shadow);
    background-image: var(--button-colored-background-image);
    box-shadow: var(--button-colored-box-shadow);
  }
  .youtube.button:hover {
    background-color: var(--youtube-hover-color);
    color: var(--button-inverted-text-color);
    text-shadow: var(--button-inverted-text-shadow);
  }
  .youtube.button:active {
    background-color: var(--youtube-down-color);
    color: var(--button-inverted-text-color);
    text-shadow: var(--button-inverted-text-shadow);
  }
  .instagram.button {
    background-color: var(--instagram-color);
    color: var(--button-inverted-text-color);
    text-shadow: var(--button-inverted-text-shadow);
    background-image: var(--button-instagram-background-image);
    box-shadow: var(--button-colored-box-shadow);
  }
  .instagram.button:hover {
    background-color: var(--instagram-hover-color);
    color: var(--button-inverted-text-color);
    text-shadow: var(--button-inverted-text-shadow);
  }
  .instagram.button:active {
    background-color: var(--instagram-down-color);
    color: var(--button-inverted-text-color);
    text-shadow: var(--button-inverted-text-shadow);
  }
  .pinterest.button {
    background-color: var(--pinterest-color);
    color: var(--button-inverted-text-color);
    text-shadow: var(--button-inverted-text-shadow);
    background-image: var(--button-colored-background-image);
    box-shadow: var(--button-colored-box-shadow);
  }
  .pinterest.button:hover {
    background-color: var(--pinterest-hover-color);
    color: var(--button-inverted-text-color);
    text-shadow: var(--button-inverted-text-shadow);
  }
  .pinterest.button:active {
    background-color: var(--pinterest-down-color);
    color: var(--button-inverted-text-color);
    text-shadow: var(--button-inverted-text-shadow);
  }
}

/* src/primitives/button/css/definition/variations/vertical.css */
@layer button.definition.variations.vertical {
  .vertical.buttons {
    display: inline-flex;
    flex-direction: column;
  }
  .vertical.buttons ::slotted(ui-button) {
    --button-width: 100%;
    --button-text-align: left;
  }
  .vertical.buttons ::slotted(ui-button:is(:first-child)) {
    --button-border-radius: var(--button-group-button-border-radius) var(--button-group-button-border-radius) 0 0;
  }
  .vertical.buttons ::slotted(ui-button:is(:last-child)) {
    --button-border-radius: 0 0 var(--button-group-button-border-radius) var(--button-group-button-border-radius);
  }
}

/* src/primitives/button/css/definition/button-definition.css */

/* src/primitives/button/css/theme/content/button-variables.css */
@layer button.theme.content.button {
  :host {
    --button-vertical-align: baseline;
    --button-vertical-margin: 0em;
    --button-horizontal-margin: var(--3px);
    --button-background-color: oklch(0.98 0 0 / 1);
    --button-background-image: var(--subtle-gradient);
    --button-background: var(--button-background-color) var(--button-background-image);
    --button-line-height: 1em;
    --button-width: auto;
    --button-vertical-padding: var(--input-vertical-padding);
    --button-horizontal-padding: var(--relative-19px);
    --button-padding: var(--button-vertical-padding) var(--button-horizontal-padding);
    --button-text-transform: none;
    --button-tap-color: transparent;
    --button-font-family: var(--page-font);
    --button-font-weight: var(--bold);
    --button-text-color: var(--black-80);
    --button-inverted-text-color: var(--white-90);
    --button-text-shadow: none;
    --button-text-align: center;
    --button-inverted-text-shadow: var(--button-text-shadow);
    --button-border-radius: var(--border-radius);
    --button-border: none;
    --button-border-color: var(--black-border-color);
    --button-border-width: 1px;
    --button-sharpen-box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.05) inset;
    --button-border-box-shadow: 0px 0px 0px var(--button-border-width) var(--button-border-color) inset;
    --button-shadow-box-shadow: var(--subtle-shadow);
    --button-box-shadow:
      var(--button-sharpen-box-shadow),
      var(--button-border-box-shadow),
      var(--button-shadow-box-shadow) ;
    --button-transition-duration: var(--duration);
    --button-transition-easing: var(--easing);
    --button-transition:
      opacity var(--button-transition-duration) var(--button-transition-easing),
      background-color var(--button-transition-duration) var(--button-transition-easing),
      color var(--button-transition-duration) var(--button-transition-easing),
      box-shadow var(--button-transition-duration) var(--button-transition-easing),
      background var(--button-transition-duration) var(--button-transition-easing) ;
    --button-will-change: initial;
  }
}

/* src/primitives/button/css/theme/content/icon-variables.css */
@layer button.theme.content.icon {
  :host {
    --button-icon-opacity: 0.4;
  }
}

/* src/primitives/button/css/theme/content/badge-variables.css */
@layer button.theme.content.badge {
  :host {
    --button-badge-margin: 0 var(--gap-2xs) 0 0;
  }
}

/* src/primitives/button/css/theme/content/label-variables.css */
@layer button.theme.content.label {
  :host {
    --labeled-label-font-size: var(--medium);
    --labeled-label-align: center;
    --labeled-label-padding: "";
    --labeled-label-font-size: var(--text-m);
    --labeled-label-border-color: var(--border-color);
    --labeled-label-border-offset: -var(--border-box-shadow-width);
    --labeled-tag-label-size: 1.85em;
    --labeled-icon-margin: 0em;
  }
}

/* src/primitives/button/css/theme/content/conditional-variables.css */
@layer button.theme.content.conditional {
  :host {
    --button-conditional-text: "";
    --button-conditional-box-shadow: var(--button-border-box-shadow), var(--button-shadow-box-shadow);
    --button-conditional-circle-size: var(--22px);
    --button-conditional-horizontal-offset: calc(var(--button-conditional-circle-size) / 2 * -1 );
    --button-conditional-background-color: var(--inverted-100);
    --button-conditional-text-shadow: var(--button-text-shadow);
    --button-conditional-text-style: var(--normal);
    --button-conditional-text-weight: var(--bold);
    --button-conditional-text-color: var(--standard-40);
    --button-conditional-padding: var(--5px) var(--5px);
  }
}

/* src/primitives/button/css/theme/plural/buttons-variables.css */
@layer button.theme.plural {
  :host {
    --button-group-box-shadow: none;
    --button-group-button-box-shadow: var(--button-box-shadow);
    --button-vertical-box-shadow: none;
    --button-group-button-offset: 0px 0px 0px 0px;
    --button-vertical-group-offset: 0px 0px 0px 0px;
    --button-group-button-border-radius: var(--border-radius);
  }
}

/* src/primitives/button/css/theme/types/link-variables.css */
@layer button.theme.types.link {
  :host {
    --button-link-padding: 0;
    --button-link-text-decoration: underline;
    --button-link-text-color: var(--link-color);
    --button-link-text-color-hover: var(--link-hover-color);
    --button-link-text-decoration-hover: underline;
  }
}

/* src/primitives/button/css/theme/types/styled-variables.css */
@layer button.theme.types.styled {
  :host {
    --button-styled-background: var(--standard-solid-5);
    --button-styled-text-shadow: none;
    --button-styled-color: var(--text-color);
    --button-styled-border-color: var(--border-color);
    --button-styled-box-shadow: var(--button-box-shadow);
    --button-styled-hover-background: var(--standard-solid-15);
    --button-styled-hover-color: var(--standard-solid-80);
    --button-styled-pressed-background: var(--standard-solid-20);
    --button-styled-pressed-color: var(--standard-solid-90);
    --button-styled-active-background: var(--standard-solid-20);
    --button-styled-active-color: var(--standard-solid-90);
    --button-outline-border-width: 1px;
    --button-outline-border-offset: -1px;
    --button-outline-border-color: var(--button-styled-border-color);
  }
}

/* src/primitives/button/css/theme/types/emphasis-variables.css */
@layer button.theme.types.emphasis {
  :host {
    --button-primary-color: var(--primary-color);
    --button-primary-background-image: var(--button-colored-background-image);
    --button-primary-box-shadow: var(--button-colored-box-shadow);
    --button-primary-text-color: var(--button-inverted-text-color);
    --button-primary-text-shadow: var(--button-inverted-text-shadow);
    --button-secondary-color: var(--secondary-color);
    --button-secondary-background-image: var(--button-colored-background-image);
    --button-secondary-box-shadow: var(--button-colored-box-shadow);
    --button-secondary-text-color: var(--button-inverted-text-color);
    --button-secondary-text-shadow: var(--button-inverted-text-shadow);
    --button-primary-color-hover: oklch(from var(--button-primary-color) calc(l + var(--hover-lightness)) c h);
    --button-secondary-color-hover: oklch(from var(--button-secondary-color) calc(l + var(--hover-lightness)) c h);
    --button-primary-color-focus: oklch(from var(--button-primary-color) calc(l + var(--focus-lightness)) c h);
    --button-secondary-color-focus: oklch(from var(--button-secondary-color) calc(l + var(--focus-lightness)) c h);
    --button-primary-color-down: oklch(from var(--button-primary-color) calc(l + var(--down-lightness)) c h);
    --button-secondary-color-down: oklch(from var(--button-secondary-color) calc(l + var(--down-lightness)) c h);
    --button-primary-color-active: oklch(from var(--button-primary-color) calc(l + var(--active-lightness)) c h);
    --button-secondary-color-active: oklch(from var(--button-secondary-color) calc(l + var(--active-lightness)) c h);
    --button-light-primary-text-color: var(--button-inverted-text-color);
    --button-light-secondary-text-color: var(--button-inverted-text-color);
  }
}

/* src/primitives/button/css/theme/types/icon-variables.css */
@layer button.theme.types.icon {
  ui-button {
  }
}

/* src/primitives/button/css/theme/types/labeled-variables.css */
@layer button.theme.types.labeled {
  ui-button {
  }
}

/* src/primitives/button/css/theme/types/labeled-icon-variables.css */
@layer button.theme.types.labeled-icon {
  ui-button {
  }
}

/* src/primitives/button/css/theme/types/toggle-variables.css */
@layer button.theme.types.toggle {
  :host {
    --button-toggle-active-background: #CFF3D8;
    --button-toggle-active-color: #22592D;
    --button-toggle-active-text-shadow: var(--button-text-shadow);
    --button-toggle-active-hover-background: #CFFFD8;
    --button-toggle-active-hover-color: #22592D;
  }
}

/* src/primitives/button/css/theme/types/animated-variables.css */
@layer button.theme.types.animated {
  :host {
    --button-animated-vertical-align: middle;
    --button-animated-z-index: 1;
    --button-animation-duration: 0.3s;
    --button-animation-easing: ease;
    --button-fade-scale-high: 1.5;
    --button-fade-scale-low: 0.75;
  }
}

/* src/primitives/button/css/theme/types/transparent-variables.css */
@layer button.theme.types.transparent {
  :host {
    --button-transparent-background-image: linear-gradient(rgba(255, 255, 255, 0.05), rgba(0, 0, 0, 0.08));
    --button-transparent-background-color: rgba(0, 0, 0, 0.03);
    --button-transparent-text-color: var(--standard-70);
    --button-transparent-box-shadow: var(--button-box-shadow);
    --button-transparent-hover-background-image: linear-gradient(rgba(255, 255, 255, 0.08), rgba(0, 0, 0, 0.1));
    --button-transparent-hover-background-color: var(--subtle-transparent-white);
    --button-transparent-hover-text-color: var(--standard-90);
    --button-transparent-hover-box-shadow: var(--button-hover-box-shadow);
    --button-transparent-pressed-background-image: var(--button-transparent-hover-background-image);
    --button-transparent-pressed-background-color: var(--transparent-white);
    --button-transparent-pressed-text-color: var(--standard-100);
    --button-transparent-pressed-box-shadow: var(--button-pressed-box-shadow);
    --button-transparent-active-background-image: var(--button-background-image);
    --button-transparent-active-background-color: rgba(0, 0, 0, 0.02);
    --button-transparent-active-text-color: var(--button-green);
    --button-transparent-active-box-shadow: var(--button-box-shadow);
  }
}

/* src/primitives/button/css/theme/states/hover-variables.css */
@layer button.theme.states.hover {
  :host {
    --button-hover-background-color: #FFFFFF;
    --button-hover-background-image: var(--button-background-image);
    --button-hover-box-shadow:
      0 -1px 0 0 rgba(0, 0, 0, 0.05) inset,
      0 0 0 1px rgba(0, 0, 0, 0.13) inset,
      0 1px 3px rgba(0, 0, 0, 0.25) ;
    --button-hover-color: var(--black-90);
    --button-hover-icon-opacity: 0.85;
  }
}

/* src/primitives/button/css/theme/states/focus-variables.css */
@layer button.theme.states.focus {
  :host {
    --button-focus-background-color: var(--button-hover-background-color);
    --button-focus-background-image: var(--button-hover-background-image);
    --button-focus-box-shadow: var(--button-hover-box-shadow);
    --button-focus-color: var(--button-hover-color);
    --button-focus-icon-opacity: 0.85;
  }
}

/* src/primitives/button/css/theme/states/pressed-variables.css */
@layer button.theme.states.pressed {
  :host {
    --button-pressed-background-image: var(--button-background-image);
    --button-pressed-background-color: var(--black-solid-5);
    --button-pressed-color: var(--black-90);
    --button-pressed-shadow-box-shadow: var(--inset-shadow);
    --button-pressed-box-shadow:
      var(--button-sharpen-box-shadow),
      var(--button-border-box-shadow),
      var(--button-pressed-shadow-box-shadow) ;
  }
}

/* src/primitives/button/css/theme/states/active-variables.css */
@layer button.theme.states.active {
  :host {
    --button-active-background-color: #DFDFDF;
    --button-active-background-image: var(--button-background-image);
    --button-active-color: var(--black-90);
    --button-active-shadow-box-shadow: var(--subtle-inset-shadow);
    --button-active-box-shadow:
      var(--button-sharpen-box-shadow),
      var(--button-border-box-shadow),
      var(--button-active-shadow-box-shadow) ;
    --button-active-hover-background-color: #DADADA;
    --button-active-hover-background-image: var(--button-active-background-image);
    --button-active-hover-color: var(--button-active-color);
    --button-active-hover-box-shadow: var(--button-active-box-shadow);
    --button-active-down-background-color: var(--button-active-background-color);
    --button-active-down-background-image: var(--button-active-background-image);
    --button-active-down-color: var(--button-active-color);
    --button-active-down-box-shadow: var(--button-active-box-shadow);
  }
}

/* src/primitives/button/css/theme/states/disabled-variables.css */
@layer button.theme.states.disabled {
  :host {
    --button-disabled-cursor: not-allowed;
    --button-disabled-opacity: 0.4;
    --button-disabled-background-color: #FFFFFF;
    --button-disabled-background-image: var(--button-background-image);
    --button-disabled-border-box-shadow: 0px 0px 0px var(--button-border-width) rgba(0, 0, 0, 0.1) inset;
    --button-disabled-shadow-box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.04);
    --button-disabled-color: var(--black-20);
    --button-disabled-box-shadow:
      var(--button-sharpen-box-shadow),
      var(--button-disabled-border-box-shadow),
      var(--button-disabled-shadow-box-shadow) ;
    --button-clickable-disabled-cursor: not-allowed;
  }
}

/* src/primitives/button/css/theme/states/loading-variables.css */
@layer button.theme.states.loading {
  :host {
    --button-loading-icon-duration: 2s;
    --button-loading-opacity: 1;
    --button-loading-transition: opacity var(--button-transition-duration) var(--button-transition-easing) ;
  }
}

/* src/primitives/button/css/theme/variations/attached-variables.css */
@layer button.theme.variations.attached {
  :host {
    --button-attached-offset: var(--button-border-width);
    --button-attached-border-shadow: 0px 0px 0px var(--button-border-width) var(--button-border-color);
    --button-attached-box-shadow: var(--button-attached-border-shadow), var(--button-shadow-box-shadow) ;
    --button-attached-z-index: var(--page-layer-2);
    --button-attached-pressed-box-shadow: var(--button-pressed-shadow-box-shadow), var(--button-attached-box-shadow) ;
    --button-attached-top-left: var(--button-border-radius) 0 0 0;
    --button-attached-top-right: 0 var(--button-border-radius) 0 0;
    --button-attached-bottom-left: 0 0 0 var(--button-border-radius);
    --button-attached-bottom-right: 0 0 var(--button-border-radius) 0;
    --button-attached-top: var(--button-border-radius) var(--button-border-radius) 0 0;
    --button-attached-bottom: 0 0 var(--button-border-radius) var(--button-border-radius);
    --button-attached-left: var(--button-border-radius) 0 0 var(--button-border-radius);
    --button-attached-right: 0 var(--button-border-radius) var(--button-border-radius) 0;
    --button-attached-all: var(--button-border-radius);
    --button-attached-none: 0;
    --button-group-attached-top-left: var(--button-group-button-border-radius) 0 0 0;
    --button-group-attached-top-right: 0 var(--button-group-button-border-radius) 0 0;
    --button-group-attached-bottom-left: 0 0 0 var(--button-group-button-border-radius);
    --button-group-attached-bottom-right: 0 0 var(--button-group-button-border-radius) 0;
    --button-group-attached-top: var(--button-group-button-border-radius) var(--button-group-button-border-radius) 0 0;
    --button-group-attached-bottom: 0 0 var(--button-group-button-border-radius) var(--button-group-button-border-radius);
    --button-group-attached-left: var(--button-group-button-border-radius) 0 0 var(--button-group-button-border-radius);
    --button-group-attached-right: 0 var(--button-group-button-border-radius) var(--button-group-button-border-radius) 0;
    --button-group-attached-all: var(--button-group-button-border-radius);
    --button-group-attached-none: 0;
  }
}

/* src/primitives/button/css/theme/variations/circular-variables.css */
@layer button.theme.variations.circular;

/* src/primitives/button/css/theme/variations/colored-variables.css */
@layer button.theme.variations.colored {
  :host {
    --button-colored-background-image: var(--button-background-image);
    --button-colored-box-shadow: var(--button-box-shadow);
    --button-inverted-text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
    --button-red: var(--red);
    --button-orange: var(--orange);
    --button-yellow: var(--yellow);
    --button-olive: var(--olive);
    --button-green: var(--green);
    --button-teal: var(--teal);
    --button-blue: var(--blue);
    --button-violet: var(--violet);
    --button-purple: var(--purple);
    --button-pink: var(--pink);
    --button-brown: var(--brown);
    --button-grey: var(--grey);
    --button-slate: var(--slate);
    --button-colored-hover-lightness: 0.05;
    --button-colored-hover-hue: 2;
    --button-red-hover: oklch(from var(--button-red) calc(l + var(--button-colored-hover-lightness)) c calc(h + var(--button-colored-hover-hue)));
    --button-orange-hover: oklch(from var(--button-orange) calc(l + var(--button-colored-hover-lightness)) c calc(h + var(--button-colored-hover-hue)));
    --button-yellow-hover: oklch(from var(--button-yellow) calc(l + var(--button-colored-hover-lightness)) c calc(h + var(--button-colored-hover-hue)));
    --button-olive-hover: oklch(from var(--button-olive) calc(l + var(--button-colored-hover-lightness)) c calc(h + var(--button-colored-hover-hue)));
    --button-green-hover: oklch(from var(--button-green) calc(l + var(--button-colored-hover-lightness)) c calc(h + var(--button-colored-hover-hue)));
    --button-teal-hover: oklch(from var(--button-teal) calc(l + var(--button-colored-hover-lightness)) c calc(h + var(--button-colored-hover-hue)));
    --button-blue-hover: oklch(from var(--button-blue) calc(l + var(--button-colored-hover-lightness)) c calc(h + var(--button-colored-hover-hue)));
    --button-violet-hover: oklch(from var(--button-violet) calc(l + var(--button-colored-hover-lightness)) c calc(h + var(--button-colored-hover-hue)));
    --button-purple-hover: oklch(from var(--button-purple) calc(l + var(--button-colored-hover-lightness)) c calc(h + var(--button-colored-hover-hue)));
    --button-pink-hover: oklch(from var(--button-pink) calc(l + var(--button-colored-hover-lightness)) c calc(h + var(--button-colored-hover-hue)));
    --button-brown-hover: oklch(from var(--button-brown) calc(l + var(--button-colored-hover-lightness)) c calc(h + var(--button-colored-hover-hue)));
    --button-grey-hover: oklch(from var(--button-grey) calc(l + var(--button-colored-hover-lightness)) c calc(h + var(--button-colored-hover-hue)));
    --button-slate-hover: oklch(from var(--button-slate) calc(l - var(--button-colored-hover-lightness)) c calc(h + var(--button-colored-hover-hue)));
    --button-colored-focus-lightness: 0.08;
    --button-colored-focus-hue: 2;
    --button-red-focus: oklch(from var(--button-red) calc(l + var(--button-colored-focus-lightness)) c calc(h + var(--button-colored-focus-hue)));
    --button-orange-focus: oklch(from var(--button-orange) calc(l + var(--button-colored-focus-lightness)) c calc(h + var(--button-colored-focus-hue)));
    --button-yellow-focus: oklch(from var(--button-yellow) calc(l + var(--button-colored-focus-lightness)) c calc(h + var(--button-colored-focus-hue)));
    --button-olive-focus: oklch(from var(--button-olive) calc(l + var(--button-colored-focus-lightness)) c calc(h + var(--button-colored-focus-hue)));
    --button-green-focus: oklch(from var(--button-green) calc(l + var(--button-colored-focus-lightness)) c calc(h + var(--button-colored-focus-hue)));
    --button-teal-focus: oklch(from var(--button-teal) calc(l + var(--button-colored-focus-lightness)) c calc(h + var(--button-colored-focus-hue)));
    --button-blue-focus: oklch(from var(--button-blue) calc(l + var(--button-colored-focus-lightness)) c calc(h + var(--button-colored-focus-hue)));
    --button-violet-focus: oklch(from var(--button-violet) calc(l + var(--button-colored-focus-lightness)) c calc(h + var(--button-colored-focus-hue)));
    --button-purple-focus: oklch(from var(--button-purple) calc(l + var(--button-colored-focus-lightness)) c calc(h + var(--button-colored-focus-hue)));
    --button-pink-focus: oklch(from var(--button-pink) calc(l + var(--button-colored-focus-lightness)) c calc(h + var(--button-colored-focus-hue)));
    --button-brown-focus: oklch(from var(--button-brown) calc(l + var(--button-colored-focus-lightness)) c calc(h + var(--button-colored-focus-hue)));
    --button-grey-focus: oklch(from var(--button-grey) calc(l + var(--button-colored-focus-lightness)) c calc(h + var(--button-colored-focus-hue)));
    --button-slate-focus: oklch(from var(--button-slate) calc(l - var(--button-colored-focus-lightness)) c calc(h + var(--button-colored-focus-hue)));
    --button-colored-pressed-lightness: -0.02;
    --button-colored-pressed-hue: 2;
    --button-red-pressed: oklch(from var(--button-red) calc(l + var(--button-colored-pressed-lightness)) c calc(h + var(--button-colored-pressed-hue)));
    --button-orange-pressed: oklch(from var(--button-orange) calc(l + var(--button-colored-pressed-lightness)) c calc(h + var(--button-colored-pressed-hue)));
    --button-yellow-pressed: oklch(from var(--button-yellow) calc(l + var(--button-colored-pressed-lightness)) c calc(h + var(--button-colored-pressed-hue)));
    --button-olive-pressed: oklch(from var(--button-olive) calc(l + var(--button-colored-pressed-lightness)) c calc(h + var(--button-colored-pressed-hue)));
    --button-green-pressed: oklch(from var(--button-green) calc(l + var(--button-colored-pressed-lightness)) c calc(h + var(--button-colored-pressed-hue)));
    --button-teal-pressed: oklch(from var(--button-teal) calc(l + var(--button-colored-pressed-lightness)) c calc(h + var(--button-colored-pressed-hue)));
    --button-blue-pressed: oklch(from var(--button-blue) calc(l + var(--button-colored-pressed-lightness)) c calc(h + var(--button-colored-pressed-hue)));
    --button-violet-pressed: oklch(from var(--button-violet) calc(l + var(--button-colored-pressed-lightness)) c calc(h + var(--button-colored-pressed-hue)));
    --button-purple-pressed: oklch(from var(--button-purple) calc(l + var(--button-colored-pressed-lightness)) c calc(h + var(--button-colored-pressed-hue)));
    --button-pink-pressed: oklch(from var(--button-pink) calc(l + var(--button-colored-pressed-lightness)) c calc(h + var(--button-colored-pressed-hue)));
    --button-brown-pressed: oklch(from var(--button-brown) calc(l + var(--button-colored-pressed-lightness)) c calc(h + var(--button-colored-pressed-hue)));
    --button-grey-pressed: oklch(from var(--button-grey) calc(l + var(--button-colored-pressed-lightness)) c calc(h + var(--button-colored-pressed-hue)));
    --button-slate-pressed: oklch(from var(--button-slate) calc(l - var(--button-colored-pressed-lightness)) c calc(h + var(--button-colored-pressed-hue)));
    --button-brown-text-color: var(--button-inverted-text-color);
    --button-brown-text-shadow: var(--button-inverted-text-shadow);
    --button-red-text-color: var(--button-inverted-text-color);
    --button-red-text-shadow: var(--button-inverted-text-shadow);
    --button-orange-text-color: var(--button-inverted-text-color);
    --button-orange-text-shadow: var(--button-inverted-text-shadow);
    --button-green-text-color: var(--button-inverted-text-color);
    --button-green-text-shadow: var(--button-inverted-text-shadow);
    --button-blue-text-color: var(--button-inverted-text-color);
    --button-blue-text-shadow: var(--button-inverted-text-shadow);
    --button-violet-text-color: var(--button-inverted-text-color);
    --button-violet-text-shadow: var(--button-inverted-text-shadow);
    --button-purple-text-color: var(--button-inverted-text-color);
    --button-purple-text-shadow: var(--button-inverted-text-shadow);
    --button-pink-text-color: var(--button-inverted-text-color);
    --button-pink-text-shadow: var(--button-inverted-text-shadow);
    --button-slate-text-color: var(--button-inverted-text-color);
    --button-slate-text-shadow: var(--button-inverted-text-shadow);
    --button-olive-text-color: var(--button-inverted-text-color);
    --button-olive-text-shadow: var(--button-inverted-text-shadow);
    --button-yellow-text-color: var(--button-inverted-text-color);
    --button-yellow-text-shadow: var(--button-inverted-text-shadow);
    --button-teal-text-color: var(--button-inverted-text-color);
    --button-teal-text-shadow: var(--button-inverted-text-shadow);
    --button-grey-text-color: var(--button-inverted-text-color);
    --button-grey-text-shadow: var(--button-inverted-text-shadow);
  }
}

/* src/primitives/button/css/theme/variations/compact-variables.css */
@layer button.theme.variations.compact {
  :host {
    --button-compact-vertical-padding: var(--6px);
    --button-compact-horizontal-padding: var(--8px);
    --button-compact-padding: var(--button-compact-horizontal-padding) var(--button-compact-vertical-padding);
    --button-compact-icon-padding: var(--button-compact-vertical-padding);
    --button-very-compact-reduction-factor: 0.4;
    --button-very-compact-vertical-padding: var(--5px);
    --button-very-compact-horizontal-padding: var(--5px);
    --button-very-compact-padding: var(--button-very-compact-horizontal-padding) var(--button-very-compact-vertical-padding);
    --button-very-compact-icon-padding: var(--button-very-compact-vertical-padding);
  }
}

/* src/primitives/button/css/theme/variations/equal-width-variables.css */
@layer button.theme.variations.equal-width {
  :host {
  }
}

/* src/primitives/button/css/theme/variations/floated-variables.css */
@layer button.theme.variations.floated {
  :host {
    --button-floated-margin: 0.25em;
  }
}

/* src/primitives/button/css/theme/variations/fluid-variables.css */
@layer button.theme.variations.fluid {
  ui-button {
  }
}

/* src/primitives/button/css/theme/variations/negative-variables.css */
@layer button.theme.variations.negative {
  :host {
    --button-negative-color: var(--negative-color);
    --button-negative-background-image: var(--button-colored-background-image);
    --button-negative-text-color: var(--button-inverted-text-color);
    --button-negative-text-shadow: var(--button-inverted-text-shadow);
    --button-negative-box-shadow: var(--button-colored-box-shadow);
    --button-negative-color-hover: oklch(from var(--button-negative-color) calc(l + var(--hover-lightness)) c h);
    --button-negative-color-focus: oklch(from var(--button-negative-color) calc(l + var(--focus-lightness)) c h);
    --button-negative-color-down: oklch(from var(--button-negative-color) calc(l + var(--down-lightness)) c h);
    --button-negative-color-active: oklch(from var(--button-negative-color) calc(l + var(--active-lightness)) c h);
    --button-subtle-negative-color: #FFFAFA;
    --button-subtle-negative-background-image: var(--button-colored-background-image);
    --button-subtle-negative-text-color: rgba(145, 50, 50, 0.9);
    --button-subtle-negative-text-shadow: var(--button-text-shadow);
    --button-subtle-negative-box-shadow: var(--button-box-shadow);
    --button-subtle-negative-color-hover: #FFEAEA;
    --button-subtle-negative-color-focus: #FFEAEA;
    --button-subtle-negative-color-down: #FFEAEA;
    --button-subtle-negative-color-active: #F1FFF7;
  }
}

/* src/primitives/button/css/theme/variations/warning-variables.css */
@layer button.theme.variations.warning {
  :host {
    --button-warning-color: var(--warning-color);
    --button-warning-background-image: var(--button-colored-background-image);
    --button-warning-text-color: var(--button-inverted-text-color);
    --button-warning-text-shadow: var(--button-inverted-text-shadow);
    --button-warning-box-shadow: var(--button-colored-box-shadow);
    --button-warning-color-hover: oklch(from var(--button-warning-color) calc(l + var(--hover-lightness)) c h);
    --button-warning-color-focus: oklch(from var(--button-warning-color) calc(l + var(--focus-lightness)) c h);
    --button-warning-color-down: oklch(from var(--button-warning-color) calc(l + var(--down-lightness)) c h);
    --button-warning-color-active: oklch(from var(--button-warning-color) calc(l + var(--active-lightness)) c h);
    --button-subtle-warning-color: #FFFDF5;
    --button-subtle-warning-background-image: var(--button-colored-background-image);
    --button-subtle-warning-text-color: rgba(135, 105, 23, 0.9);
    --button-subtle-warning-text-shadow: var(--button-text-shadow);
    --button-subtle-warning-box-shadow: var(--button-box-shadow);
    --button-subtle-warning-color-hover: #FFF5DD;
    --button-subtle-warning-color-focus: #FFF5DD;
    --button-subtle-warning-color-down: #FFF5DD;
    --button-subtle-warning-color-active: #FFFDEA;
  }
}

/* src/primitives/button/css/theme/variations/info-variables.css */
@layer button.theme.variations.info {
  :host {
    --button-info-color: var(--info-color);
    --button-info-background-image: var(--button-colored-background-image);
    --button-info-text-color: var(--button-inverted-text-color);
    --button-info-text-shadow: var(--button-inverted-text-shadow);
    --button-info-box-shadow: var(--button-colored-box-shadow);
    --button-info-color-hover: oklch(from var(--button-info-color) calc(l + var(--hover-lightness)) c h);
    --button-info-color-focus: oklch(from var(--button-info-color) calc(l + var(--focus-lightness)) c h);
    --button-info-color-down: oklch(from var(--button-info-color) calc(l + var(--down-lightness)) c h);
    --button-info-color-active: oklch(from var(--button-info-color) calc(l + var(--active-lightness)) c h);
    --button-subtle-info-color: #F8FEFF;
    --button-subtle-info-background-image: var(--button-colored-background-image);
    --button-subtle-info-text-color: rgba(23, 94, 135, 0.9);
    --button-subtle-info-text-shadow: var(--button-text-shadow);
    --button-subtle-info-box-shadow: var(--button-box-shadow);
    --button-subtle-info-color-hover: #DEFBFF;
    --button-subtle-info-color-focus: #DEFBFF;
    --button-subtle-info-color-down: #DEFBFF;
    --button-subtle-info-color-active: #E4FBFF;
  }
}

/* src/primitives/button/css/theme/variations/positive-variables.css */
@layer button.theme.variations.positive {
  :host {
    --button-positive-color: var(--positive-color);
    --button-positive-background-image: var(--button-colored-background-image);
    --button-positive-text-color: var(--button-inverted-text-color);
    --button-positive-text-shadow: var(--button-inverted-text-shadow);
    --button-positive-box-shadow: var(--button-colored-box-shadow);
    --button-positive-color-hover: oklch(from var(--positive-color) calc(l + var(--hover-lightness)) c h);
    --button-positive-color-focus: oklch(from var(--positive-color) calc(l + var(--focus-lightness)) c h);
    --button-positive-color-down: oklch(from var(--positive-color) calc(l + var(--down-lightness)) c h);
    --button-positive-color-active: oklch(from var(--positive-color) calc(l + var(--active-lightness)) c h);
    --button-subtle-positive-color: #F3FFF6;
    --button-subtle-positive-background-image: var(--button-colored-background-image);
    --button-subtle-positive-text-color: rgba(38, 127, 81, 0.9);
    --button-subtle-positive-text-shadow: var(--button-text-shadow);
    --button-subtle-positive-box-shadow: var(--button-box-shadow);
    --button-subtle-positive-color-hover: #EAFFEA;
    --button-subtle-positive-color-focus: #EAFFEA;
    --button-subtle-positive-color-down: #EAFFEA;
    --button-subtle-positive-color-active: #F1FFF7;
  }
}

/* src/primitives/button/css/theme/variations/separate-variables.css */
@layer button.theme.variations.separate {
  :host {
    --button-separate-spacing: var(--5px);
  }
}

/* src/primitives/button/css/theme/variations/sizing-variables.css */
@layer button.theme.variations.sizing {
  :host {
    --button-mini: var(--mini);
    --button-tiny: var(--tiny);
    --button-small: var(--small);
    --button-medium: inherit;
    --button-large: var(--large);
    --button-big: var(--big);
    --button-huge: var(--huge);
    --button-massive: var(--massive);
  }
}

/* src/primitives/button/css/theme/variations/social-variables.css */
@layer button.theme.variations.social {
  :host {
    --button-instagram-background-image: var(--instagram-gradient);
    --facebook-hover-color: oklch(from var(--facebook-color) calc(l - 0.05) c calc(h + 10));
    --twitter-hover-color: oklch(from var(--twitter-color) calc(l - 0.05) c calc(h + 10));
    --linked-in-hover-color: oklch(from var(--linked-in-color) calc(l - 0.05) c calc(h + 10));
    --youtube-hover-color: oklch(from var(--youtube-color) calc(l - 0.05) c calc(h + 10));
    --instagram-hover-color: oklch(from var(--instagram-color) calc(l - 0.05) c calc(h + 10));
    --pinterest-hover-color: oklch(from var(--pinterest-color) calc(l - 0.05) c calc(h + 10));
    --facebook-down-color: oklch(from var(--facebook-color) calc(l - 0.1) c h);
    --twitter-down-color: oklch(from var(--twitter-color) calc(l - 0.1) c h);
    --linked-in-down-color: oklch(from var(--linked-in-color) calc(l - 0.1) c h);
    --youtube-down-color: oklch(from var(--youtube-color) calc(l - 0.1) c h);
    --instagram-down-color: oklch(from var(--instagram-color) calc(l - 0.1) c h);
    --pinterest-down-color: oklch(from var(--pinterest-color) calc(l - 0.1) c h);
    --facebook-focus-color: oklch(from var(--facebook-color) calc(l - 0.08) c calc(h + 15));
    --twitter-focus-color: oklch(from var(--twitter-color) calc(l - 0.08) c calc(h + 15));
    --linked-in-focus-color: oklch(from var(--linked-in-color) calc(l - 0.08) c calc(h + 15));
    --youtube-focus-color: oklch(from var(--youtube-color) calc(l - 0.08) c calc(h + 15));
    --instagram-focus-color: oklch(from var(--instagram-color) calc(l - 0.08) c calc(h + 15));
    --pinterest-focus-color: oklch(from var(--pinterest-color) calc(l - 0.08) c calc(h + 15));
  }
}

/* src/primitives/button/css/theme/variations/vertical-variables.css */
@layer button.theme.variations.vertical {
  ui-button {
  }
}

/* src/primitives/button/css/theme/button-theme.css */

/* src/primitives/button/css/button.css */
